const resources = {
  de: {
    translation: {
      common: {
        close: "Schliessen",
        language: {
          de: "Deutsch",
          en: "Englisch",
          pt: "Portugiesisch",
        },
      },
      layout: {
        appTitle: "Olymp",
        nav: {
          navigation: "Navigation",
          general: "Allgemein",
        },
        menu: {
          home: "Home",
          catalog: "Datenkatalog",
          cohorts: "Kohorten",
          requests: "Anfragen",
          settings: "Einstellungen",
          adminPanel: "Admin-Bereich",
          help: "Hilfe & Support",
        },
        userRole: {
          currentRole: "Aktuelle Rolle: {{role}}",
          menuTitle: "Demo: Rolle wählen",
          user: "Nutzer",
          dataSteward: "Data Steward",
          admin: "Administrator",
        },
        support: {
          needHelp: "Benötigen Sie Hilfe?",
          contactSupport: "Support kontaktieren",
        },
        language: {
          ariaLabel: "Sprache wechseln",
          tooltip: "Sprache: {{language}}",
        },
      },
      login: {
        subtitle: "Olymp",
        email: "E-Mail",
        emailPlaceholder: "test@argus.com",
        password: "Passwort",
        signIn: "Anmelden",
        signingIn: "Wird angemeldet...",
        failed: "Login fehlgeschlagen",
        genericError: "Ein Fehler ist aufgetreten",
      },
      dashboard: {
        hero: {
          title: "Willkommen im ARGUS Olymp Data Catalog",
          subtitle: "Entdecken, Analysieren und Nutzen Sie Ihre klinischen Forschungsdaten",
          catalogCta: "Datenkatalog durchsuchen",
          cohortsCta: "Kohorten verwalten",
          requestsCta: "Datenanfragen",
        },
        onboarding: {
          title: "Willkommen bei Olymp",
          subtitle: "Ein kurzer Einstieg für den ersten Login.",
          intro: "Olymp folgt einem einfachen Ablauf: erst Parameter strukturieren, dann Kohorten definieren, danach Daten anfragen.",
          primaryAction: "Mit dem Datenkatalog starten",
          dismiss: "Später",
          rememberTitle: "Wichtig für den Ablauf",
          rememberText: "List A definiert Kohorten-Parameter, die Sie später im Cohort Builder für Ein- und Ausschlusskriterien verwenden. List B definiert, welche Daten in Anfragen extrahiert werden.",
          steps: {
            catalog: {
              title: "Datenkatalog",
              description: "Erstellen Sie zwei Listen: List A für Kohorten-Parameter und List B für die spätere Extraktion.",
              action: "Datenkatalog öffnen",
            },
            cohortBuilder: {
              title: "Cohort Builder",
              description: "Nutzen Sie die Parameter aus List A, um Ein- und Ausschlusskriterien zu definieren und Ihre Kohorte zu verfeinern.",
              action: "Cohort Builder öffnen",
            },
            requests: {
              title: "Anfragen",
              description: "Kombinieren Sie die fertige Kohorte mit List B, um eine Datenanfrage zu stellen.",
              action: "Anfragen öffnen",
            },
          },
        },
        stats: {
          parametersInCatalog: "Parameter im Katalog",
          omopMapped: "OMOP gemappt",
          coverage: "{{value}}% Coverage",
          myFavorites: "Meine Favoriten",
          dataRequests: "Datenanfragen",
          cohortsCount: "{{count}} Kohorten",
        },
        widgets: {
          favorites: "Meine Favoriten",
          viewAll: "Alle anzeigen",
          noFavorites: "Noch keine Favoriten",
          noFavoritesHint: "Markieren Sie Parameter im Katalog als Favoriten",
          favoritesUnavailable: "Favoriten momentan nicht verfügbar",
          favoritesCount_one: "{{count}} Parameter als Favorit markiert",
          favoritesCount_other: "{{count}} Parameter als Favoriten markiert",
          goToCatalog: "Zum Katalog",
          recentActivity: "Letzte Aktivitäten",
          myLists: "Meine Parameterlisten",
          notifications: "Benachrichtigungen",
          pending: "Ausstehend",
          public: "Öffentlich",
          private: "Privat",
          parameterCount: "{{count}} Parameter",
        },
        timeAgo: {
          fewMinutes: "vor wenigen Minuten",
          hours: "vor {{count}} Stunden",
          oneDay: "vor 1 Tag",
          days: "vor {{count}} Tagen",
        },
        loadError: "Nicht alle Kacheln konnten geladen werden. Angezeigte Zahlen können unvollständig sein.",
      },
      workflowGuide: {
        title: "Olymp Workflow",
        subtitle: "Datenkatalog -> Kohorten -> Anfragen: in 3 Schritten von Parametern zu Extraktionen.",
        learnMore: "Mehr erfahren",
        tip: "Tipp: Beginnen Sie im <catalog>Datenkatalog</catalog> mit zwei Listen (List A und List B), definieren Sie dann im <cohort>Cohort Builder</cohort> Kohortenkriterien mit den Parametern aus List A und erstellen Sie anschließend in <request>Anfragen</request> die Extraktion mit List B.",
        steps: {
          catalog: "Datenkatalog",
          cohorts: "Kohorten",
          requests: "Anfragen",
        },
        tooltips: {
          catalog: "Start: Erstellen Sie zwei Parameterlisten (List A und List B). List A enthält Kohorten-Parameter (WHO), List B enthält Extraktions-Parameter (WHAT).",
          cohorts: "Definieren Sie die Patientengruppe mit Ein- und Ausschlusskriterien basierend auf den Parametern aus List A.",
          requests: "Kombinieren Sie eine Kohorte (WHO) mit einer Extraktionsliste (List B, WHAT) und starten Sie eine Datenanfrage.",
        },
      },
      dataCatalogHelp: {
        title: "Hilfe: Parameterlisten & Workflow",
        intro: "Parameterlisten sammeln klinische Parameter für den Workflow. List A definiert Kohorten-Parameter (WHO), die im Cohort Builder zur Festlegung der Kriterien genutzt werden. List B definiert die Extraktion (WHAT).",
        listA: {
          title: "List A - Kohorten-Parameter",
          hint: "Enthält Parameter (WHO), die im Cohort Builder zur Definition von Ein- und Ausschlusskriterien verwendet werden.",
        },
        listB: {
          title: "List B - Datenextraktion",
          hint: "Für Parameter, die in Anfragen extrahiert werden.",
        },
        workflow: "Workflow",
      },
      dataCatalog: {
        title: "Datenkatalog",
        resultCount: "{{count}} Parameter gefunden",
        overviewTooltip: "Überblick: Parameterlisten, List A/List B und Workflow",
        overviewAria: "Datenkatalog Überblick öffnen",
        startMappingBatch: "Mapping-Batch starten",
        parameterListsTitle: "Parameterlisten",
        parameterListsTooltip: "Parameterlisten bündeln klinische Merkmale. List A liefert die Parameterbasis für Kriterien im Cohort Builder, List B wird für die Extraktion in Requests genutzt.",
        activeWorkingListOne: "Aktive Arbeitsliste:",
        activeWorkingListMany: "Aktive Arbeitslisten:",
        noListSelected: "Keine Liste ausgewählt (max. 2 für Vergleich)",
        selectUpToTwo: "Wählen Sie bis zu 2 Listen zum Vergleichen",
        selectSecondList: "Wählen Sie eine weitere Liste zum Vergleichen",
        maxReached: "Maximum erreicht (2 Listen)",
        privateLists: "PRIVATE LISTEN",
        publicLists: "OEFFENTLICHE LISTEN",
        deactivate: "Deaktivieren",
        manageAllLists: "Alle Listen verwalten",
        onlyActiveList: "Nur in aktiver Liste",
        allParameters: "Alle Parameter",
        comparison: "Vergleich:",
        overviewDialogTitle: "Datenkatalog - Überblick",
        overviewDialogDescription: "Im Datenkatalog erstellen und verwalten Sie Parameterlisten für den End-to-End Workflow.",
        overviewDialogListATitle: "List A (Cohort Parameters):",
        overviewDialogListADescription: "Definiert Kohorten-Parameter, die im Cohort Builder zur Erstellung von Ein- und Ausschlusskriterien genutzt werden.",
        overviewDialogListBTitle: "List B (Data Extraction):",
        overviewDialogListBDescription: "Definiert, welche Daten später in Requests extrahiert werden.",
        overviewDialogWorkflow: "Workflow: Data Catalog -> Cohort Builder -> Requests",
      },
      cohorts: {
        title: "Kohorten",
        subtitle: "Verwalten Sie Ihre Patientenkohorten",
        createTitle: "Neue Kohorte erstellen",
        editTitle: "Kohorte bearbeiten",
        createSubtitle: "Wählen Sie eine Parameterliste und definieren Sie Ihre Kohortenkriterien",
        editSubtitle: "Bearbeiten Sie die Kohorte \"{{name}}\"",
        confirmDelete: "Moechten Sie diese Kohorte wirklich loeschen?",
        emptyState: "Noch keine Kohorten definiert. Klicken Sie auf \"Neue Kohorte erstellen\" um zu beginnen.",
        labels: {
          by: "von",
          includeShort: "Ein",
          excludeShort: "Aus",
          public: "Oeffentlich",
          private: "Privat",
          changed: "geaendert",
          copy: "Kopie",
          imported: "Importiert",
          currentUser: "Aktueller Benutzer",
        },
        tooltips: {
          estimatedPatients: "Geschaetzte Patientenanzahl",
          public: "Oeffentlich - fuer alle Benutzer sichtbar",
          private: "Privat - nur fuer Sie sichtbar",
        },
        actions: {
          create: "Neue Kohorte erstellen",
          import: "Importieren",
          edit: "Bearbeiten",
          delete: "Loeschen",
          duplicate: "Duplizieren",
          exportJson: "Als JSON exportieren",
          back: "Zurueck zur Uebersicht",
          cancel: "Abbrechen",
        },
        table: {
          description: "Beschreibung",
          parameterList: "Parameterliste",
          criteria: "Kriterien",
          patients: "Patienten",
          visibility: "Sichtbarkeit",
          created: "Erstellt",
          actions: "Aktionen",
        },
        importDialog: {
          title: "Kohorte importieren",
          description: "Waehlen Sie eine JSON-Datei aus, um eine Kohorte zu importieren. Die Datei sollte eine zuvor exportierte Kohorte enthalten.",
          selectFile: "JSON-Datei auswaehlen",
        },
        messages: {
          created: "Kohorte erfolgreich erstellt!",
          updated: "Kohorte erfolgreich aktualisiert!",
          deleted: "Kohorte erfolgreich geloescht",
          duplicated: "Kohorte erfolgreich dupliziert",
          exported: "Kohorte \"{{name}}\" erfolgreich exportiert",
          imported: "Kohorte \"{{name}}\" erfolgreich importiert",
          invalidImport: "Ungueltiges Kohortenformat: Name und Einschlusskriterien fehlen",
          importReadError: "Fehler beim Lesen der JSON-Datei:",
        },
      },
      requests: {
        subtitle: "Verwalten Sie Ihre Datenanfragen",
        status: {
          pendingApproval: "Genehmigung ausstehend",
          inProgress: "In Bearbeitung",
          inReview: "In Pruefung",
          completed: "Abgeschlossen",
          rejected: "Abgelehnt",
        },
        type: {
          feasibilityReview: "Machbarkeitspruefung",
          feasibility: "Machbarkeit",
          dataProvision: "Datenbereitstellung",
          cohortCreation: "Kohortenerstellung / Fallzahlermittlung",
          cohortCreationHint: "Beantragen Sie die Erstellung der Kohorte und erhalten Sie die Anzahl der Faelle",
          dataExtraction: "Datenextraktion",
          dataExtractionHint: "Beantragen Sie die Extraktion von Parametern fuer die Fallnummern der Kohorte",
        },
        labels: {
          patients: "Patienten",
          currentUser: "Aktueller Benutzer",
          you: "Sie",
          parametersCount: "{{count}} Parameter",
        },
        actions: {
          back: "Zurueck",
          next: "Weiter",
          newRequest: "Neue Anfrage",
          createRequest: "Anfrage erstellen",
        },
        table: {
          type: "Typ",
          cohort: "Kohorte",
          status: "Status",
          parameters: "Parameter",
          requestedAt: "Angefragt am",
        },
        empty: {
          title: "Noch keine Anfragen gestellt",
          subtitle: "Erstellen Sie Ihre erste Anfrage mit dem Button oben",
        },
        wizard: {
          newRequestTitle: "Neue Anfrage erstellen",
          stepOf: "Schritt {{current}} von {{total}}",
          successTitle: "Anfrage erfolgreich erstellt!",
          successSubtitle: "Die Anfrage wird geoeffnet...",
          steps: {
            selectCohort: "Kohorte auswaehlen",
            selectType: "Anfrageart waehlen",
            selectParameters: "Parameter auswaehlen",
            notes: "Notizen",
            summary: "Zusammenfassung",
          },
          selectCohortHelp: "Waehlen Sie die Kohorte, fuer die Sie eine Anfrage erstellen moechten.",
          selectCohortLabel: "Kohorte auswaehlen*",
          cohortSelected: "Kohorte ausgewaehlt",
          noCohorts: "Keine Kohorten verfuegbar.",
          cohortsUnavailable: "Kohorten konnten nicht geladen werden. Bitte spaeter erneut versuchen.",
          selectTypeHelp: "Waehlen Sie die Art der Anfrage aus.",
          selectParametersHelp: "Waehlen Sie eine Parameterliste und die zu extrahierenden Parameter aus.",
          selectParameterListLabel: "Parameterliste auswaehlen*",
          availableParameters: "{{count}} verfuegbare Parameter",
          selectParametersLabel: "Parameter auswaehlen*",
          selectParametersPlaceholder: "Beginnen Sie mit der Eingabe...",
          selectAtLeastOne: "Bitte waehlen Sie mindestens einen Parameter aus",
          parametersSelected: "{{count}} Parameter ausgewaehlt",
          selectListFirst: "Bitte waehlen Sie zuerst eine Parameterliste aus.",
          notesHelp: "Fuegen Sie optionale Notizen oder zusaetzliche Informationen hinzu.",
          notesPlaceholder: "Zusaetzliche Informationen oder Anmerkungen...",
          notesHelper: "Optional: Beschreiben Sie besondere Anforderungen oder Details",
          reviewBeforeSubmit: "Ueberpruefen Sie Ihre Anfrage vor dem Absenden.",
        },
        messages: {
          underReview: "Ihre Anfrage wird geprueft.",
        },
      },
    },
  },
  en: {
    translation: {
      common: {
        close: "Close",
        language: {
          de: "German",
          en: "English",
          pt: "Portuguese",
        },
      },
      layout: {
        appTitle: "Olymp",
        nav: {
          navigation: "Navigation",
          general: "General",
        },
        menu: {
          home: "Home",
          catalog: "Data Catalog",
          cohorts: "Cohorts",
          requests: "Requests",
          settings: "Settings",
          adminPanel: "Admin Panel",
          help: "Help & Support",
        },
        userRole: {
          currentRole: "Current role: {{role}}",
          menuTitle: "Demo: Select role",
          user: "User",
          dataSteward: "Data Steward",
          admin: "Administrator",
        },
        support: {
          needHelp: "Need help?",
          contactSupport: "Contact support",
        },
        language: {
          ariaLabel: "Switch language",
          tooltip: "Language: {{language}}",
        },
      },
      login: {
        subtitle: "Olymp",
        email: "Email",
        emailPlaceholder: "test@argus.com",
        password: "Password",
        signIn: "Sign In",
        signingIn: "Signing in...",
        failed: "Login failed",
        genericError: "An error occurred",
      },
      dashboard: {
        hero: {
          title: "Welcome to ARGUS Olymp Data Catalog",
          subtitle: "Discover, analyze, and use your clinical research data",
          catalogCta: "Search data catalog",
          cohortsCta: "Manage cohorts",
          requestsCta: "Data requests",
        },
        onboarding: {
          title: "Welcome to Olymp",
          subtitle: "A short walkthrough for the first login.",
          intro: "Olymp follows a simple flow: first structure parameters, then define cohorts, and finally request data.",
          primaryAction: "Start in Data Catalog",
          dismiss: "Later",
          rememberTitle: "Keep this in mind",
          rememberText: "List A defines cohort parameters that you later use in Cohort Builder to build inclusion and exclusion criteria. List B defines which data should be extracted in Requests.",
          steps: {
            catalog: {
              title: "Data Catalog",
              description: "Create two lists: List A for cohort parameters and List B for later extraction.",
              action: "Open Data Catalog",
            },
            cohortBuilder: {
              title: "Cohort Builder",
              description: "Use the parameters from List A to define inclusion and exclusion criteria and refine your cohort.",
              action: "Open Cohort Builder",
            },
            requests: {
              title: "Requests",
              description: "Combine the finished cohort with List B to submit a data request.",
              action: "Open Requests",
            },
          },
        },
        stats: {
          parametersInCatalog: "Parameters in catalog",
          omopMapped: "OMOP mapped",
          coverage: "{{value}}% coverage",
          myFavorites: "My favorites",
          dataRequests: "Data requests",
          cohortsCount: "{{count}} cohorts",
        },
        widgets: {
          favorites: "My favorites",
          viewAll: "View all",
          noFavorites: "No favorites yet",
          noFavoritesHint: "Mark parameters as favorites in the catalog",
          favoritesUnavailable: "Favorites currently unavailable",
          favoritesCount_one: "{{count}} parameter marked as favorite",
          favoritesCount_other: "{{count}} parameters marked as favorites",
          goToCatalog: "Go to catalog",
          recentActivity: "Recent activity",
          myLists: "My parameter lists",
          notifications: "Notifications",
          pending: "Pending",
          public: "Public",
          private: "Private",
          parameterCount: "{{count}} parameters",
        },
        timeAgo: {
          fewMinutes: "a few minutes ago",
          hours: "{{count}} hours ago",
          oneDay: "1 day ago",
          days: "{{count}} days ago",
        },
        loadError: "Not all tiles could be loaded. Numbers shown may be incomplete.",
      },
      workflowGuide: {
        title: "Olymp Workflow",
        subtitle: "Data Catalog -> Cohorts -> Requests: from parameters to extraction in 3 steps.",
        learnMore: "Learn more",
        tip: "Tip: Start in the <catalog>Data Catalog</catalog> with two lists (List A and List B), then define cohort criteria in <cohort>Cohort Builder</cohort> using parameters from List A, and finally create the extraction in <request>Requests</request> with List B.",
        steps: {
          catalog: "Data Catalog",
          cohorts: "Cohorts",
          requests: "Requests",
        },
        tooltips: {
          catalog: "Start: Create two parameter lists (List A and List B). List A stores cohort parameters (WHO), List B stores extraction parameters (WHAT).",
          cohorts: "Define the patient group with inclusion and exclusion criteria based on parameters from List A.",
          requests: "Combine a cohort (WHO) with an extraction list (List B, WHAT) and start a data request.",
        },
      },
      dataCatalogHelp: {
        title: "Help: Parameter Lists & Workflow",
        intro: "Parameter lists collect clinical parameters for the workflow. List A defines cohort parameters (WHO) used in Cohort Builder to define criteria. List B defines extraction data (WHAT).",
        listA: {
          title: "List A - Cohort Parameters",
          hint: "Stores parameters (WHO) used in Cohort Builder to define inclusion and exclusion criteria.",
        },
        listB: {
          title: "List B - Data Extraction",
          hint: "Used for parameters that will be extracted in requests.",
        },
        workflow: "Workflow",
      },
      dataCatalog: {
        title: "Data Catalog",
        resultCount: "{{count}} parameters found",
        overviewTooltip: "Overview: parameter lists, List A/List B, and workflow",
        overviewAria: "Open data catalog overview",
        startMappingBatch: "Start mapping batch",
        parameterListsTitle: "Parameter Lists",
        parameterListsTooltip: "Parameter lists bundle clinical features. List A provides parameter input for criteria in Cohort Builder, List B is used for extraction in Requests.",
        activeWorkingListOne: "Active working list:",
        activeWorkingListMany: "Active working lists:",
        noListSelected: "No list selected (max. 2 for comparison)",
        selectUpToTwo: "Select up to 2 lists for comparison",
        selectSecondList: "Select one more list for comparison",
        maxReached: "Maximum reached (2 lists)",
        privateLists: "PRIVATE LISTS",
        publicLists: "PUBLIC LISTS",
        deactivate: "Deactivate",
        manageAllLists: "Manage all lists",
        onlyActiveList: "Only active list",
        allParameters: "All parameters",
        comparison: "Comparison:",
        overviewDialogTitle: "Data Catalog - Overview",
        overviewDialogDescription: "In the Data Catalog, you create and manage parameter lists for the end-to-end workflow.",
        overviewDialogListATitle: "List A (Cohort Parameters):",
        overviewDialogListADescription: "Defines cohort parameters that are used in Cohort Builder to build inclusion and exclusion criteria.",
        overviewDialogListBTitle: "List B (Data Extraction):",
        overviewDialogListBDescription: "Defines which data will be extracted later in requests.",
        overviewDialogWorkflow: "Workflow: Data Catalog -> Cohort Builder -> Requests",
      },
      cohorts: {
        title: "Cohorts",
        subtitle: "Manage your patient cohorts",
        createTitle: "Create new cohort",
        editTitle: "Edit cohort",
        createSubtitle: "Select a parameter list and define your cohort criteria",
        editSubtitle: "Edit cohort \"{{name}}\"",
        confirmDelete: "Do you really want to delete this cohort?",
        emptyState: "No cohorts defined yet. Click \"Create new cohort\" to get started.",
        labels: {
          by: "by",
          includeShort: "Inc",
          excludeShort: "Exc",
          public: "Public",
          private: "Private",
          changed: "changed",
          copy: "Copy",
          imported: "Imported",
          currentUser: "Current user",
        },
        tooltips: {
          estimatedPatients: "Estimated patient count",
          public: "Public - visible to all users",
          private: "Private - visible only to you",
        },
        actions: {
          create: "Create new cohort",
          import: "Import",
          edit: "Edit",
          delete: "Delete",
          duplicate: "Duplicate",
          exportJson: "Export as JSON",
          back: "Back to overview",
          cancel: "Cancel",
        },
        table: {
          description: "Description",
          parameterList: "Parameter list",
          criteria: "Criteria",
          patients: "Patients",
          visibility: "Visibility",
          created: "Created",
          actions: "Actions",
        },
        importDialog: {
          title: "Import cohort",
          description: "Select a JSON file to import a cohort. The file should contain a previously exported cohort.",
          selectFile: "Select JSON file",
        },
        messages: {
          created: "Cohort created successfully!",
          updated: "Cohort updated successfully!",
          deleted: "Cohort deleted successfully",
          duplicated: "Cohort duplicated successfully",
          exported: "Cohort \"{{name}}\" exported successfully",
          imported: "Cohort \"{{name}}\" imported successfully",
          invalidImport: "Invalid cohort format: missing name and inclusion criteria",
          importReadError: "Error reading JSON file:",
        },
      },
      requests: {
        subtitle: "Manage your data requests",
        status: {
          pendingApproval: "Pending approval",
          inProgress: "In progress",
          inReview: "In review",
          completed: "Completed",
          rejected: "Rejected",
        },
        type: {
          feasibilityReview: "Feasibility review",
          feasibility: "Feasibility",
          dataProvision: "Data provision",
          cohortCreation: "Cohort creation / case count estimation",
          cohortCreationHint: "Request cohort creation and receive estimated case counts",
          dataExtraction: "Data extraction",
          dataExtractionHint: "Request parameter extraction for selected cohort cases",
        },
        labels: {
          patients: "patients",
          currentUser: "Current user",
          you: "You",
          parametersCount: "{{count}} parameters",
        },
        actions: {
          back: "Back",
          next: "Next",
          newRequest: "New request",
          createRequest: "Create request",
        },
        table: {
          type: "Type",
          cohort: "Cohort",
          status: "Status",
          parameters: "Parameters",
          requestedAt: "Requested at",
        },
        empty: {
          title: "No requests submitted yet",
          subtitle: "Create your first request with the button above",
        },
        wizard: {
          newRequestTitle: "Create new request",
          stepOf: "Step {{current}} of {{total}}",
          successTitle: "Request created successfully!",
          successSubtitle: "Opening request...",
          steps: {
            selectCohort: "Select cohort",
            selectType: "Select request type",
            selectParameters: "Select parameters",
            notes: "Notes",
            summary: "Summary",
          },
          selectCohortHelp: "Select the cohort for which you want to create a request.",
          selectCohortLabel: "Select cohort*",
          cohortSelected: "Cohort selected",
          noCohorts: "No cohorts available.",
          cohortsUnavailable: "Cohorts could not be loaded. Please try again later.",
          selectTypeHelp: "Select the request type.",
          selectParametersHelp: "Select a parameter list and the parameters to be extracted.",
          selectParameterListLabel: "Select parameter list*",
          availableParameters: "{{count}} available parameters",
          selectParametersLabel: "Select parameters*",
          selectParametersPlaceholder: "Start typing...",
          selectAtLeastOne: "Please select at least one parameter",
          parametersSelected: "{{count}} parameters selected",
          selectListFirst: "Please select a parameter list first.",
          notesHelp: "Add optional notes or additional details.",
          notesPlaceholder: "Additional information or notes...",
          notesHelper: "Optional: Describe special requirements or details",
          reviewBeforeSubmit: "Review your request before submitting.",
        },
        messages: {
          underReview: "Your request is being reviewed.",
        },
      },
    },
  },
};

const deepClone = (value) => JSON.parse(JSON.stringify(value));

const mergeDeep = (target, source) => {
  Object.keys(source).forEach((key) => {
    const sourceValue = source[key];
    if (sourceValue && typeof sourceValue === "object" && !Array.isArray(sourceValue)) {
      if (!target[key] || typeof target[key] !== "object" || Array.isArray(target[key])) {
        target[key] = {};
      }
      mergeDeep(target[key], sourceValue);
      return;
    }
    target[key] = sourceValue;
  });
};

mergeDeep(resources.de.translation, {
  common: {
    language: {
      pt: "Portugiesisch",
    },
    country: {
      de: "Deutschland",
      en: "Vereinigtes Königreich",
      pt: "Portugal",
    },
  },
  workflowGuide: {
    subtitle:
      "Datenkatalog -> Kohorten -> Anfragen: Erstellen Sie zuerst zwei Listen (List A = Kohorten-Parameter, List B = Extraktion), definieren Sie dann die Kohortenkriterien im Cohort Builder mit List A und starten Sie danach die Anfrage.",
    tip:
      "Tipp: Kriterien sind medizinische Regeln (z. B. Alter > 65 oder Diagnose-Code). Erstellen Sie im <catalog>Datenkatalog</catalog> zuerst List A (WHO-Parameter) und List B (WHAT), definieren Sie im <cohort>Cohort Builder</cohort> die Kohortenkriterien mit List A und senden Sie in <request>Anfragen</request> die Extraktion mit Kohorte + List B.",
    tooltips: {
      catalog:
        "Schritt 1: Erstellen Sie zwei Parameterlisten. List A enthält Kohorten-Parameter (WHO), die später für Kriterien genutzt werden; List B enthält Felder für die spätere Extraktion (WHAT).",
      cohorts:
        "Schritt 2: Definieren Sie die Kohorte mit List A. Kriterien bedeuten Ein-/Ausschluss-Regeln, die festlegen, welche Patienten zur Population gehören.",
      requests:
        "Schritt 3: Kombinieren Sie die fertige Kohorte (WHO) mit List B (WHAT), um die gewünschte Datenanfrage zu starten.",
    },
  },
  dataCatalogHelp: {
    intro:
      "Erstellen Sie im Datenkatalog immer zwei Parameterlisten für den Workflow: List A definiert Kohorten-Parameter (WHO), mit denen Sie später Kriterien im Cohort Builder festlegen; List B definiert die Datenextraktion (WHAT).",
    criteriaMeaning:
      "Kriterien sind medizinische Bedingungen wie Ein-/Ausschlussregeln (z. B. Alter, Diagnosen, Laborgrenzen), mit denen Sie später im Cohort Builder die Patientengruppe eingrenzen.",
    listA: {
      hint: "List A enthält Kohorten-Parameter (WHO), die im Cohort Builder zur Definition von Ein- und Ausschlusskriterien verwendet werden.",
    },
    listB: {
      hint: "List B enthält die Extraktionsfelder (WHAT): Datenpunkte, die in Anfragen exportiert werden.",
    },
  },
  dataCatalog: {
    labels: {
      listAEnabled: "Liste A aktiviert:",
      listComparisonEnabled: "Listen-Vergleich aktiviert (A / B):",
    },
    messages: {
      alreadyInList: 'Parameter "{{parameter}}" ist bereits in "{{list}}"',
      pendingSuggestion: 'Vorschlag für "{{parameter}}" in "{{list}}" ist bereits ausstehend',
      addedToList: 'Parameter "{{parameter}}" zu "{{list}}" hinzugefügt',
      suggestionSent: 'Vorschlag für "{{parameter}}" in "{{list}}" gesendet (Approval erforderlich)',
      addedGeneric: '"{{parameter}}" zu "{{list}}" hinzugefügt',
      removedFromList: '"{{parameter}}" aus "{{list}}" entfernt',
      aiFiltersApplied: "{{count}} KI-vorgeschlagene Parameter als Filter angewendet",
      listAEnabledInfo:
        'Parameter in der Liste sind mit einem blauen "A" markiert. Klicken Sie auf "A", um den Parameter zu entfernen. Klicken Sie auf den Listen-Button bei Parametern, um sie',
      listAEnabledInfoDirect: "direkt hinzuzufügen.",
      listAEnabledInfoSuggest: "vorzuschlagen (erfordert Approval).",
      listComparisonInfo:
        "Nutzen Sie die Filter-Chips oben. In der Listen-Spalte sehen Sie A/B-Kreise; Klick entfernt den Parameter aus der jeweiligen Liste.",
    },
  },
  requests: {
    tabs: {
      overview: "Übersicht",
      timeline: "Timeline",
      chat: "Chat",
    },
    details: {
      requestId: "Anfrage-ID",
      type: "Typ",
      requestedBy: "Angefragt von",
      requestedAt: "Angefragt am",
      parameters: "Parameter",
      estimatedCases: "Geschätzte Fallzahl",
      selectedParameters: "Ausgewählte Parameter ({{count}})",
      patients: "Patienten",
    },
    timeline: {
      submitted: "Anfrage eingereicht",
      submittedBy: "Von {{user}} eingereicht",
      submittedDetails: "Anfrage-ID: {{id}}",
      review: "Prüfung durch Data Steward Team",
      reviewDone: "Anfrage wurde geprüft und zur Bearbeitung freigegeben",
      reviewPending: "Anfrage wird durch das Data Steward Team geprüft",
      reviewDoneDetails: "Rechtliche und technische Machbarkeit bestätigt",
      approved: "Genehmigt und zugewiesen",
      approvedDone: "Anfrage wurde an das Datenmanagement-Team weitergeleitet",
      approvedDoneDetails: "Zuständiger Bearbeiter wurde informiert",
      processing: "Datenextraktion in Bearbeitung",
      processingDone: "Daten wurden erfolgreich extrahiert",
      processingInProgress: "Datenextraktion läuft",
      processingDetails: "{{count}} Parameter werden verarbeitet",
      provided: "Bereitgestellt",
      providedDone: "Daten stehen zum Download bereit",
      providedDoneDetails: "Export wurde erfolgreich generiert",
      pending: "Ausstehend",
      timeSuffix: "Uhr",
    },
    wizard: {
      summary: {
        selectedCohort: "Ausgewählte Kohorte",
        requestType: "Anfrageart",
        selectedParameters: "Ausgewählte Parameter",
        notes: "Notizen",
        moreSelected: "+{{count}} weitere",
        submitHint: "Die Anfrage wird zur Prüfung an das Data Steward Team weitergeleitet.",
      },
    },
    chat: {
      inputPlaceholder: "Nachricht eingeben...",
    },
  },
  settings: {
    title: "Einstellungen",
    subtitle: "Verwalten Sie Ihre Konto-, Unternehmens- und Anwendungseinstellungen.",
    loading: "Einstellungen werden geladen…",
    tabAriaLabel: "Einstellungs-Tabs",
    authErrors: {
      notSignedIn: "Nicht angemeldet",
      unauthenticated: "Die Sitzung ist nicht mehr gültig. Bitte melden Sie sich erneut an.",
      connectionFailed: "Die Einstellungen konnten nicht geladen werden.",
    },
    authStatus: {
      connected: "Mit dem Auth-Service verbunden",
    },
    time: {
      month: "Monat",
      months: "Monate",
      year: "Jahr",
      years: "Jahre",
    },
    tabs: {
      profile: "Profil",
      organization: "Abteilung",
      notifications: "Benachrichtigungen",
      billing: "Abrechnung",
      api: "API & Integrationen",
      appearance: "Darstellung",
      admin: "Admin-Bereich",
    },
    authWarningTitle: "Auth Service",
    authWarningFallback: "Verbindung fehlgeschlagen",
    authWarningBody:
      "Die Verbindung zum Authentifizierungs-Service konnte nicht hergestellt werden. Einige Funktionen sind möglicherweise eingeschränkt.",
    buttons: {
      saveChanges: "Änderungen speichern",
      saveSettings: "Einstellungen speichern",
      saveAllApi: "Alle API-Einstellungen speichern",
      saveWebhook: "Speichern",
      createOrganization: "Unternehmen erstellen",
      addMember: "Mitglied hinzufügen",
      inviteMember: "Mitglied einladen",
      invite: "Einladen",
      cancel: "Abbrechen",
      add: "Hinzufügen",
      connect: "Verbinden",
      testWebhook: "Webhook testen",
      generateNewKey: "Neuen Schlüssel generieren",
      changeBillingDetails: "Abrechnungsdetails ändern",
      changeServicePackage: "Servicepaket ändern",
      endOtherSessions: "Alle anderen Sitzungen beenden",
      viewFullLogs: "Vollständige Protokolle anzeigen",
      pdf: "PDF",
      gotIt: "Verstanden",
    },
    sections: {
      profile: {
        personalInformation: "Persönliche Informationen",
        securitySettings: "Sicherheitseinstellungen",
        summary: {
          email: "E-Mail",
          phone: "Telefon",
          address: "Adresse",
        },
        fields: {
          name: "Name",
          email: "E-Mail",
          phone: "Telefon",
          role: "Position/Rolle",
          company: "Unternehmen",
          department: "Abteilung",
          address: "Adresse",
          changePassword: "Passwort ändern",
        },
        helpers: {
          emailManaged: "Die E-Mail-Adresse wird über Ihr Konto verwaltet und kann hier nicht geändert werden.",
          passwordChangePlaceholder: "Bitte im Tab Datenschutz & Sicherheit ändern",
          passwordChangeHelp: "Verwenden Sie die vollständige Passwortänderung im Tab Datenschutz & Sicherheit.",
          goToSecurity: "Zur Sicherheit",
          twoFactor: "Erhöhen Sie die Sicherheit Ihres Kontos durch eine zusätzliche Verifizierung bei der Anmeldung.",
        },
        twoFactorLabel: "Zwei-Faktor-Authentifizierung aktivieren",
        avatarComingSoon: "Profilbild-Upload ist in Vorbereitung.",
        uploadAvatar: "Profilbild hochladen",
        orgContext: {
          title: "Meine Organisation",
          company: "Unternehmen",
          department: "Abteilung",
          team: "Team",
          role: "Rolle",
          noInfo: "Noch nicht zugewiesen",
        },
      },
      organization: {
        information: "Unternehmensinformationen",
        members: "Teammitglieder",
        logoComingSoon: "Logo-Upload ist in Vorbereitung.",
        uploadLogo: "Logo hochladen",
        summary: {
          size: "Unternehmensgröße",
          website: "Website",
          primaryColor: "Primärfarbe",
        },
        fields: {
          name: "Unternehmensname",
          type: "Unternehmenstyp",
          size: "Unternehmensgröße",
          industry: "Branche",
          website: "Website",
          primaryColor: "Primärfarbe",
        },
        types: {
          hospital: "Krankenhaus",
          clinic: "Klinik",
          research: "Forschungseinrichtung",
          university: "Universität",
          pharma: "Pharmaunternehmen",
          biotech: "Biotech-Unternehmen",
          other: "Sonstiges",
        },
        sizes: {
          "1-50": "1-50 Mitarbeiter",
          "51-200": "51-200 Mitarbeiter",
          "201-1000": "201-1000 Mitarbeiter",
          "1001-5000": "1001-5000 Mitarbeiter",
          "5000+": "5000+ Mitarbeiter",
        },
        roles: {
          admin: "Administrator",
          reviewer: "Reviewer",
          analyst: "Analyst",
          viewer: "Betrachter",
          member: "Mitglied",
          dept_admin: "Abteilungsadmin",
          team_admin: "Teamadmin",
          data_steward: "Data Steward",
          guest: "Gast",
        },
        actions: {
          edit: "Bearbeiten",
          remove: "Entfernen",
        },
        dialog: {
          title: "Neues Teammitglied hinzufügen",
          description: "Geben Sie die E-Mail-Adresse des Benutzers ein. Der Benutzer muss bereits ein Argus-Konto besitzen.",
          email: "E-Mail-Adresse",
          role: "Rolle",
        },
        teamHint: {
          title: "Team-Mitglieder",
          description: "{{count}} Mitglied(er) in Ihrem Unternehmen",
          goToTeam: "Zum Team",
        },
        noOrgYet: "Noch kein Unternehmen erstellt.",
        companyReadOnlyNote: "Unternehmensdaten werden von Ihrem Administrator verwaltet und können hier nicht bearbeitet werden.",
        accordion: {
          company: "Unternehmen",
          departments: "Abteilungen",
          noDepartments: "Noch keine Abteilungen konfiguriert.",
          createDepartment: "Abteilung erstellen",
          teams: "Teams",
          noTeams: "Noch keine Teams konfiguriert.",
          createTeam: "Team erstellen",
          members: "Mitglieder",
          leaveTeam: "Team verlassen",
        },
      },
      team: {
        title: "Team-Mitglieder",
        subtitle: "{{count}} Mitglied(er) in Ihrem Unternehmen",
        noMembers: "Noch keine Mitglieder eingeladen.",
        youLabel: "Du",
        noOrg: {
          title: "Noch kein Unternehmen",
          description: "Erstellen Sie zuerst ein Unternehmen, um Mitglieder einzuladen.",
          goToOrg: "Zum Unternehmen",
        },
        editRoleDialog: {
          title: "Rolle bearbeiten",
          description: "Rolle für {{email}} ändern",
        },
        removeConfirm: {
          title: "Mitglied entfernen?",
          description: "Möchten Sie {{name}} wirklich aus dem Unternehmen entfernen?",
          confirm: "Entfernen",
        },
      },
      notifications: {
        emailTitle: "E-Mail-Benachrichtigungen",
        inAppTitle: "In-App-Benachrichtigungen",
        items: {
          newRequests: {
            title: "Neue Datenanfragen",
            email: "Erhalten Sie eine E-Mail, wenn neue Anfragen eingehen",
            inApp: "Erhalten Sie eine Benachrichtigung, wenn neue Anfragen eingehen",
          },
          statusChanges: {
            title: "Statusänderungen",
            email: "Erhalten Sie eine E-Mail, wenn sich der Status Ihrer Anfragen ändert",
            inApp: "Erhalten Sie eine Benachrichtigung, wenn sich der Status Ihrer Anfragen ändert",
          },
          messages: {
            title: "Neue Nachrichten",
            email: "Erhalten Sie eine E-Mail, wenn Sie neue Nachrichten erhalten",
            inApp: "Erhalten Sie eine Benachrichtigung, wenn Sie neue Nachrichten erhalten",
          },
          billing: {
            title: "Abrechnungsinformationen",
            email: "Erhalten Sie eine E-Mail zu Abrechnungen und Zahlungen",
            inApp: "Erhalten Sie eine Benachrichtigung zu Abrechnungen und Zahlungen",
          },
          weeklyReport: {
            title: "Wöchentlicher Bericht",
            email: "Erhalten Sie einen wöchentlichen Bericht über Ihre Anfragen",
          },
        },
      },
      privacy: {
        privacyTitle: "Datenschutzeinstellungen",
        dataSharingTitle: "Datenfreigabe",
        dataSharingDescription: "Legen Sie fest, wie viele Informationen über Ihre Anfragen mit Partnerkliniken geteilt werden.",
        dataSharingOptions: {
          minimal: "Minimal - Nur notwendige Daten teilen",
          standard: "Standard - Grundlegende Informationen teilen",
          extended: "Erweitert - Detaillierte Informationen teilen",
        },
        anonymizeLabel: "Ergebnisse anonymisieren",
        anonymizeDescription: "Wenn aktiviert, werden alle Patientendaten in Analyseergebnissen automatisch anonymisiert.",
        analyticsLabel: "Nutzungsanalyse zulassen",
        analyticsDescription: "Erlauben Sie uns, anonymisierte Nutzungsdaten zu sammeln, um den Service zu verbessern.",
        retentionTitle: "Aufbewahrungszeitraum für Anfragedaten",
        retentionDescription: "Legen Sie fest, wie lange Ihre Anfragedaten gespeichert werden sollen.",
        retentionMarks: {
          months6: "6 Monate",
          year1: "1 Jahr",
          years2: "2 Jahre",
          years3: "3 Jahre",
          years5: "5 Jahre",
        },
      },
      security: {
        title: "Sicherheitseinstellungen",
        twoFactorTitle: "Zwei-Faktor-Authentifizierung",
        statusEnabled: "Aktiviert",
        statusDisabled: "Deaktiviert",
        enabledHelp: "Ihre Anmeldung ist durch einen zweiten Faktor geschützt.",
        disabledHelp: "Aktivieren Sie diese Option für zusätzliche Sicherheit.",
        currentPassword: "Aktuelles Passwort",
        newPassword: "Neues Passwort",
        confirmPassword: "Neues Passwort bestätigen",
        sessionManagement: "Sitzungsverwaltung",
        sessionHelp: "Beendet alle aktiven Sitzungen außer der aktuellen.",
        accessLogsTitle: "Datenzugriffsprotokolle",
        accessLogsDescription: "Hier können Sie Ihre Kontoaktivitäten einsehen.",
        accessLogsComingSoon: "Zugriffsprotokolle sind in Vorbereitung und noch nicht verfügbar.",
        accessLogsEmpty: "Noch keine Aktivitätsprotokolle vorhanden.",
        refreshLogs: "Protokolle aktualisieren",
        accessLogCols: {
          event: "Ereignis",
          description: "Beschreibung",
          ip: "IP-Adresse",
          time: "Zeitpunkt",
        },
      },
      twoFa: {
        setupTitle: "Zwei-Faktor-Authentifizierung einrichten",
        setupDescription: "Scannen Sie den QR-Code mit Ihrer Authenticator-App (z. B. Google Authenticator oder Authy) und geben Sie dann den 6-stelligen Code ein.",
        manualEntryLabel: "Manueller Schlüssel (zum Kopieren klicken)",
        clickToCopy: "In die Zwischenablage kopieren",
        secretCopied: "Schlüssel kopiert.",
        codeLabel: "6-stelliger Code",
        verifyButton: "Verifizieren & aktivieren",
        disableTitle: "Zwei-Faktor-Authentifizierung deaktivieren",
        disableDescription: "Sind Sie sicher, dass Sie die Zwei-Faktor-Authentifizierung deaktivieren möchten? Ihr Konto wird dadurch weniger geschützt.",
        disableButton: "Deaktivieren",
      },
      billing: {
        currentPlan: "Aktueller Plan",
        nextBilling: "Nächste Abrechnung:",
        paymentMethod: "Zahlungsmethode:",
        institutionNumber: "Institutionsnummer:",
        invoiceHistory: "Rechnungshistorie",
        invoiceId: "Rechnungs-ID",
        date: "Datum",
        amount: "Betrag",
        status: "Status",
        actions: "Aktionen",
        billingAddress: "Rechnungsadresse",
        contactPerson: "Ansprechpartner",
        invoiceEmail: "E-Mail für Rechnungen",
        vatId: "Umsatzsteuer-ID",
        paid: "bezahlt",
      },
      api: {
        settingsTitle: "API-Einstellungen",
        enableAccess: "API-Zugriff aktivieren",
        enableAccessDescription: "Ermöglicht den Zugriff auf ARGUS-Daten über die API.",
        apiKey: "API-Schlüssel",
        newKeyWarning: "Achtung: Das Generieren eines neuen Schlüssels macht den alten ungültig.",
        toggleKeyVisibility: "API-Schlüssel anzeigen oder verbergen",
        copyKey: "API-Schlüssel kopieren",
        rateLimit: "Rate Limit",
        rateLimitDescription: "Maximale Anzahl an API-Anfragen pro Stunde.",
        requestsPerHour: "Anfragen/Stunde",
        webhookTitle: "Webhook-Konfiguration",
        webhookDescription: "Konfigurieren Sie Webhooks, um Benachrichtigungen über Ereignisse zu erhalten.",
        webhookUrl: "Webhook-URL",
        webhookEvents: "Ereignisse",
        analysisResults: "Neue Analyseergebnisse",
        statusChanges: "Statusänderungen",
        messages: "Neue Nachrichten",
        ipWhitelist: "IP-Whitelist",
        ipWhitelistDescription: "Beschränken Sie den API-Zugriff auf bestimmte IP-Adressen.",
        newIpAddress: "Neue IP-Adresse",
        newIpPlaceholder: "z.B. 192.168.1.1",
        aiProvider: {
          title: "KI-Anbieter",
          description: "Anbieter, Modell-ID und (bei lokalen Modellen) Endpunkt fuer KI-gestuetzte Funktionen. Die Vorschlagsliste ist eine Hilfe, keine Einschraenkung -- jede Modell-ID laesst sich frei eingeben.",
          fields: {
            provider: "Anbieter",
            providerPlaceholder: "z. B. OpenRouter",
            model: "Modell-ID",
            modelPlaceholder: "z. B. claude-sonnet-5",
            endpoint: "Endpunkt",
          },
        },
        llmModels: {
          title: "LLM-Modelle",
          description: "Modelle mit eigenem API-Schluessel fuer diese Instanz. Der Schluessel wird nur gesendet -- nie zurueckgelesen, nie angezeigt.",
          columns: {
            provider: "Anbieter",
            model: "Modell-ID",
            label: "Bezeichnung",
            status: "Status",
            credential: "Schluessel",
            actions: "Aktionen",
          },
          status: {
            active: "Aktiv",
            inactive: "Inaktiv",
          },
          credential: {
            present: "Schluessel hinterlegt",
            missing: "Kein Schluessel hinterlegt",
          },
          empty: "Noch keine Modelle hinterlegt.",
          addTitle: "Modell hinzufuegen",
          fields: {
            // Eigene Feldnamen statt "Anbieter"/"Modell-ID" wie in
            // AiProviderSettings (#95): beide Formulare stehen im selben
            // API-Tab, ein gemeinsamer Labeltext waere fuer
            // `getByLabelText` (und fuer Screenreader) nicht eindeutig.
            provider: "LLM-Anbieter",
            model: "LLM-Modell-ID",
            label: "Bezeichnung",
            apiKey: "API-Schluessel",
          },
          deleteAction: "Modell loeschen",
          deleteTitle: "Modell loeschen",
          deleteConfirm: "Soll \"{{label}}\" wirklich geloescht werden? Der hinterlegte Schluessel wird dabei entfernt.",
          deleteButton: "Loeschen",
          testConnection: "Verbindung testen",
          testing: "Teste Verbindung...",
          testSuccess: "Erfolgreich ({{latency}} ms)",
          testError: "Fehlgeschlagen{{message}}",
          loadError: "Modelle konnten nicht geladen werden.",
          saveError: "Modell konnte nicht gespeichert werden.",
          deleteError: "Modell konnte nicht geloescht werden.",
        },
        integrations: "Integrationen",
        integrationsCards: {
          rStudio: "Verbinden Sie die ARGUS-Platform mit R Studio für automatisierte Datenanalysen.",
          python: "Nutzen Sie Python-Bibliotheken für automatisierte Datenanalysen und Ergebnisaufbereitung.",
          tableau: "Erstellen Sie Dashboards zur Visualisierung von Anfragen und Analysestatistiken.",
        },
      },
      appearance: {
        title: "Erscheinungsbild",
        theme: "Farbschema",
        themes: {
          light: "Hell",
          dark: "Dunkel",
          system: "System",
        },
        primaryColor: "Primärfarbe",
        fontSize: "Schriftgröße",
        fontScale: {
          small: "Klein",
          normal: "Normal",
          large: "Groß",
        },
        animations: "Animationen",
        animationsEnabled: "Animationen aktivieren",
        languageRegion: "Sprache und Region",
        switchLanguage: "Sprache wechseln",
        dateFormat: "Datumsformat",
        timeZone: "Zeitzone",
        timeZones: {
          berlin: "Europa/Berlin (GMT+1)",
          london: "Europa/London (GMT)",
          newYork: "Amerika/New York (GMT-5)",
          tokyo: "Asien/Tokio (GMT+9)",
        },
        dashboard: "Dashboard-Einstellungen",
        defaultHomepage: "Standard-Startseite",
        homepageOptions: {
          dashboard: "Dashboard",
          requests: "Eingehende Anfragen",
          negotiations: "Verhandlungen",
          executions: "Ausführungen",
        },
        widgets: {
          title: "Dashboard-Widgets",
          incomingRequests: "Eingehende Anfragen",
          statistics: "Statistiken",
          runningAnalyses: "Laufende Analysen",
          paymentOverview: "Zahlungsübersicht",
          activityLog: "Aktivitätsprotokoll",
        },
      },
    },
    snackbars: {
      authRequired: "Fehler: Nicht angemeldet",
      noOrganization: "Fehler: Kein Unternehmen gefunden",
      orgNameRequired: "Bitte geben Sie einen Unternehmensnamen ein.",
      emailRequired: "Bitte geben Sie eine E-Mail-Adresse ein.",
      profileSaved: "Profil-Einstellungen wurden erfolgreich gespeichert.",
      organizationCreated: "Unternehmen wurde erfolgreich erstellt.",
      organizationSaved: "Unternehmens-Einstellungen wurden erfolgreich gespeichert.",
      notificationsSaved: "Benachrichtigungs-Einstellungen wurden erfolgreich gespeichert.",
      privacySaved: "Datenschutz- und Sicherheitseinstellungen wurden erfolgreich gespeichert.",
      apiSaved: "API-Einstellungen wurden erfolgreich gespeichert.",
      appearanceSaved: "Darstellungs-Einstellungen wurden erfolgreich gespeichert.",
      genericSaved: "{{section}}-Einstellungen wurden erfolgreich gespeichert.",
      saveError: "Fehler beim Speichern: {{message}}",
      addMemberSuccess: "Teammitglied wurde erfolgreich hinzugefügt.",
      addMemberNotFound: "Kein Argus-Konto mit dieser E-Mail gefunden.",
      addMemberError: "Fehler beim Hinzufügen: {{message}}",
      removeMemberSuccess: "Teammitglied wurde entfernt.",
      removeMemberError: "Fehler beim Entfernen: {{message}}",
      memberRoleUpdated: "Mitgliederrolle wurde aktualisiert.",
      memberRoleUpdateError: "Fehler beim Aktualisieren der Rolle: {{message}}",
      apiKeyGenerated: "Neuer API-Schlüssel wurde generiert und gespeichert.",
      apiKeyGenerateError: "API-Schlüssel konnte nicht generiert werden: {{message}}",
      duplicateIp: "Diese IP-Adresse ist bereits vorhanden.",
      invalidIp: "Ungültiges IP-Adressformat. Bitte verwenden Sie z. B. 192.168.1.1 oder 10.0.0.0/24.",
      oldPasswordRequired: "Bitte geben Sie Ihr aktuelles Passwort ein.",
      passwordTooShort: "Das neue Passwort muss mindestens 8 Zeichen lang sein.",
      passwordMismatch: "Das neue Passwort und die Bestätigung stimmen nicht überein.",
      sessionEnded: "Alle anderen Sitzungen wurden beendet.",
      sessionEndError: "Fehler beim Beenden der Sitzungen: {{message}}",
      webhookTested: "Webhook-Test gesendet.",
      webhookTestError: "Webhook-Test fehlgeschlagen: {{message}}",
      apiKeyCopied: "API-Schlüssel in die Zwischenablage kopiert.",
      avatarSaved: "Profilbild gespeichert.",
      avatarSaveError: "Profilbild konnte nicht gespeichert werden: {{message}}",
      logoSaved: "Logo gespeichert.",
      logoSaveError: "Logo konnte nicht gespeichert werden: {{message}}",
      invalidImageType: "Bitte wählen Sie eine gültige Bilddatei aus.",
      imageTooLarge: "Die Bilddatei darf maximal 5 MB groß sein.",
      twoFaSetupError: "2FA-Einrichtung fehlgeschlagen: {{message}}",
      twoFaCodeRequired: "Bitte geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.",
      twoFaEnabled: "Zwei-Faktor-Authentifizierung wurde erfolgreich aktiviert.",
      twoFaVerifyError: "Code-Verifizierung fehlgeschlagen: {{message}}",
      twoFaDisabled: "Zwei-Faktor-Authentifizierung wurde deaktiviert.",
      twoFaDisableError: "2FA konnte nicht deaktiviert werden: {{message}}",
    },
  },
  supportPage: {
    title: "Hilfe & Dokumentation",
    subtitle: "Zentrale Hilfe für den Olymp Workflow: Data Catalog -> Cohort Builder -> Requests.",
    searchPlaceholder: "Suche in Hilfe, Workflow, FAQ, Glossar und Kontakt...",
    tabAriaLabel: "Hilfe und Dokumentation Tabs",
    chips: {
      gettingStarted: "Getting Started",
      workflow: "Workflow",
      faqs: "FAQs",
      glossary: "Glossar",
      contact: "Kontakt",
    },
    tabs: {
      gettingStarted: "Getting Started",
      workflow: "Workflow",
      faqs: "FAQs",
      glossary: "Glossar",
      contact: "Kontakt",
    },
    noResults: 'Keine Treffer für "{{term}}". Versuchen Sie einen anderen Suchbegriff.',
    sections: {
      gettingStartedTitle: "Getting Started",
      gettingStartedSubtitle:
        "Starten Sie mit dem End-to-End Ablauf in drei Schritten und navigieren Sie direkt in die passende Seite.",
      workflowTitle: "Workflow Guides",
      workflowSubtitle: "Detaillierte Orientierung für Data Catalog, Cohort Builder und Requests.",
      glossaryTitle: "Glossar",
      glossaryTerm: "Begriff",
      glossaryDefinition: "Definition",
      contactTitle: "Kontakt & Support",
      contactSubtitle: "Für Hilfe, Bug Reports und Feature Requests stehen Ihnen folgende Kanäle bereit.",
    },
    content: {
      gettingStartedSteps: [
        {
          title: "1. Datenkatalog vorbereiten",
          description: "Erstellen Sie List A (Kohorten-Parameter) und List B (Extraktion), um Ihren Workflow sauber zu starten.",
          actionLabel: "Zum Datenkatalog",
          actionPath: "/catalog",
        },
        {
          title: "2. Kohorte aufbauen",
          description: "Definieren und verfeinern Sie Ihre Population im Cohort Builder (List- und Graph-Ansicht).",
          actionLabel: "Zum Cohort Builder",
          actionPath: "/cohorts",
        },
        {
          title: "3. Anfrage absenden",
          description: "Kombinieren Sie WHO (Kohorte) und WHAT (List B) und erstellen Sie eine Datenanfrage.",
          actionLabel: "Zu Anfragen",
          actionPath: "/requests",
        },
      ],
      workflowGuides: [
        {
          title: "Data Catalog",
          topics: [
            "Parameterlisten erstellen und verwalten",
            "List A = Parameterbasis für Ein-/Ausschlusskriterien im Cohort Builder",
            "List B = Extraktionsfelder für Requests",
          ],
          path: "/catalog",
        },
        {
          title: "Cohort Builder",
          topics: [
            "Zwischen List View und Graph View wechseln",
            "Sub-Kohorten für Verfeinerungen anlegen",
            "Kriterien bearbeiten und Ausführung simulieren",
          ],
          path: "/cohorts",
        },
        {
          title: "Requests",
          topics: [
            "Anfrage mit Kohorte + List B erstellen",
            "Status und Fortschritt überwachen",
            "Ergebnisse prüfen und exportieren",
          ],
          path: "/requests",
        },
      ],
      faqItems: [
        {
          question: "Was ist der Unterschied zwischen List A und List B?",
          answer: "List A definiert Kohorten-Parameter (WHO), die im Cohort Builder zur Definition der Kohortenkriterien genutzt werden. List B definiert die zu extrahierenden Datenfelder (WHAT).",
        },
        {
          question: "Wie wechsle ich zwischen List View und Graph View?",
          answer: "Im Cohort Builder können Sie oben per Toggle zwischen Listen- und Graph-Ansicht wechseln.",
        },
        {
          question: "Wie lange dauert eine Datenanfrage?",
          answer: "Das hängt vom Umfang der Daten und der Kohortenkomplexität ab. Der Status wird in Anfragen transparent angezeigt.",
        },
      ],
      glossaryItems: [
        { term: "Cohort", definition: "Definierte Patientengruppe mit spezifischen Kriterien." },
        { term: "Sub-Cohort", definition: "Verfeinerte Teilmenge einer übergeordneten Kohorte." },
        { term: "Cohort Builder", definition: "Werkzeug zur Erstellung und Pflege hierarchischer Kohorten." },
        { term: "Graph View", definition: "Interaktive Knoten-Ansicht der Kohortenstruktur." },
        { term: "List View", definition: "Tabellarische Ansicht zur Verwaltung von Kohorten." },
        { term: "List A", definition: "Parameterliste, die im Cohort Builder als Basis zur Definition von Ein-/Ausschlusskriterien genutzt wird." },
        { term: "List B", definition: "Parameterliste für Datenextraktion in Requests." },
      ],
      contactItems: [
        {
          title: "Support E-Mail",
          description: "Bei Fragen oder Problemen erhalten Sie Unterstützung durch unser Team.",
          value: "support@argus-health.de",
          href: "mailto:support@argus-health.de",
        },
        {
          title: "Bug Report",
          description: "Technische Fehler direkt als Ticket erfassen.",
          value: "Issue in GitLab erstellen",
          href: "https://gitlab.it.argus-evaluation.com/argus/applications/argus-platform/-/issues/new",
        },
        {
          title: "Feature Request",
          description: "Verbesserungsvorschläge für den Workflow dokumentieren.",
          value: "Neues Feature vorschlagen",
          href: "https://gitlab.it.argus-evaluation.com/argus/applications/argus-platform/-/issues/new",
        },
      ],
    },
  },
});

mergeDeep(resources.en.translation, {
  common: {
    language: {
      pt: "Portuguese",
    },
    country: {
      de: "Germany",
      en: "United Kingdom",
      pt: "Portugal",
    },
  },
  workflowGuide: {
    subtitle:
      "Data Catalog -> Cohorts -> Requests: first create two lists (List A = cohort parameters, List B = extraction), then define cohort criteria in Cohort Builder using List A, then run the request.",
    tip:
      "Tip: Criteria are medical rules (for example age > 65 or diagnosis code). In <catalog>Data Catalog</catalog>, first create List A (WHO parameters) and List B (WHAT), then define cohort criteria in <cohort>Cohort Builder</cohort> using List A, and finally create the extraction in <request>Requests</request> with cohort + List B.",
    tooltips: {
      catalog:
        "Step 1: Create two parameter lists. List A stores cohort parameters (WHO) used later to define criteria, List B stores fields for later extraction (WHAT).",
      cohorts:
        "Step 2: Define the cohort using List A. Criteria are inclusion/exclusion rules that decide which patients belong to the population.",
      requests:
        "Step 3: Combine the completed cohort (WHO) with List B (WHAT) to start the data request.",
    },
  },
  dataCatalogHelp: {
    intro:
      "Always create two parameter lists in Data Catalog for the workflow: List A defines cohort parameters (WHO) used in Cohort Builder to define criteria, and List B defines data extraction (WHAT).",
    criteriaMeaning:
      "Criteria are medical conditions such as inclusion/exclusion rules (for example age, diagnoses, lab thresholds) used later in Cohort Builder to narrow the patient population.",
    listA: {
      hint: "List A stores cohort parameters (WHO) used in Cohort Builder to define inclusion and exclusion criteria.",
    },
    listB: {
      hint: "List B stores extraction fields (WHAT): data points exported in Requests.",
    },
  },
  dataCatalog: {
    labels: {
      listAEnabled: "List A active:",
      listComparisonEnabled: "List comparison active (A / B):",
    },
    messages: {
      alreadyInList: 'Parameter "{{parameter}}" is already in "{{list}}"',
      pendingSuggestion: 'Suggestion for "{{parameter}}" in "{{list}}" is already pending',
      addedToList: 'Added parameter "{{parameter}}" to "{{list}}"',
      suggestionSent: 'Sent suggestion for "{{parameter}}" to "{{list}}" (approval required)',
      addedGeneric: 'Added "{{parameter}}" to "{{list}}"',
      removedFromList: 'Removed "{{parameter}}" from "{{list}}"',
      aiFiltersApplied: "Applied {{count}} AI-suggested parameters as filters",
      listAEnabledInfo:
        'Parameters in the list are marked with a blue "A". Click "A" to remove the parameter. Use the list button to add them',
      listAEnabledInfoDirect: "directly.",
      listAEnabledInfoSuggest: "as suggestion (approval required).",
      listComparisonInfo:
        "Use the filter chips above. In the list column you see A/B circles; click to remove from that list.",
    },
  },
  requests: {
    tabs: {
      overview: "Overview",
      timeline: "Timeline",
      chat: "Chat",
    },
    details: {
      requestId: "Request ID",
      type: "Type",
      requestedBy: "Requested by",
      requestedAt: "Requested at",
      parameters: "Parameters",
      estimatedCases: "Estimated case count",
      selectedParameters: "Selected parameters ({{count}})",
      patients: "patients",
    },
    timeline: {
      submitted: "Request submitted",
      submittedBy: "Submitted by {{user}}",
      submittedDetails: "Request ID: {{id}}",
      review: "Data steward review",
      reviewDone: "Request reviewed and released for processing",
      reviewPending: "Request is being reviewed by the data steward team",
      reviewDoneDetails: "Legal and technical feasibility confirmed",
      approved: "Approved and assigned",
      approvedDone: "Request forwarded to the data management team",
      approvedDoneDetails: "Responsible assignee has been notified",
      processing: "Data extraction in progress",
      processingDone: "Data extracted successfully",
      processingInProgress: "Data extraction running",
      processingDetails: "{{count}} parameters are being processed",
      provided: "Delivered",
      providedDone: "Data is ready for download",
      providedDoneDetails: "Export generated successfully",
      pending: "Pending",
      timeSuffix: "",
    },
    wizard: {
      summary: {
        selectedCohort: "Selected cohort",
        requestType: "Request type",
        selectedParameters: "Selected parameters",
        notes: "Notes",
        moreSelected: "+{{count}} more",
        submitHint: "The request will be forwarded to the data steward team for review.",
      },
    },
    chat: {
      inputPlaceholder: "Type message...",
    },
  },
  settings: {
    title: "Settings",
    subtitle: "Manage your account, company, and application settings.",
    loading: "Loading settings…",
    tabAriaLabel: "Settings tabs",
    authErrors: {
      notSignedIn: "Not signed in",
      unauthenticated: "Your session is no longer valid. Please sign in again.",
      connectionFailed: "The settings could not be loaded.",
    },
    authStatus: {
      connected: "Connected to the auth service",
    },
    time: {
      month: "month",
      months: "months",
      year: "year",
      years: "years",
    },
    tabs: {
      profile: "Profile",
      organization: "Department",
      notifications: "Notifications",
      billing: "Billing",
      api: "API & Integrations",
      appearance: "Appearance",
      admin: "Admin Panel",
    },
    authWarningTitle: "Auth service",
    authWarningFallback: "Connection failed",
    authWarningBody:
      "The connection to the authentication service could not be established. Some features may be limited.",
    buttons: {
      saveChanges: "Save changes",
      saveSettings: "Save settings",
      saveAllApi: "Save all API settings",
      saveWebhook: "Save",
      createOrganization: "Create company",
      addMember: "Add member",
      inviteMember: "Invite member",
      invite: "Invite",
      cancel: "Cancel",
      add: "Add",
      connect: "Connect",
      testWebhook: "Test webhook",
      generateNewKey: "Generate new key",
      changeBillingDetails: "Change billing details",
      changeServicePackage: "Change service package",
      endOtherSessions: "End all other sessions",
      viewFullLogs: "View full logs",
      pdf: "PDF",
      gotIt: "Got it",
    },
    sections: {
      profile: {
        personalInformation: "Personal information",
        securitySettings: "Security settings",
        summary: {
          email: "Email",
          phone: "Phone",
          address: "Address",
        },
        fields: {
          name: "Name",
          email: "Email",
          phone: "Phone",
          role: "Position/Role",
          company: "Company",
          department: "Department",
          address: "Address",
          changePassword: "Change password",
        },
        helpers: {
          emailManaged: "The email address is managed through your account and cannot be changed here.",
          passwordChangePlaceholder: "Please change this in the Privacy & Security tab",
          passwordChangeHelp: "Use the full password change flow in the Privacy & Security tab.",
          goToSecurity: "Go to Security",
          twoFactor: "Increase your account security with an additional verification step during sign-in.",
        },
        twoFactorLabel: "Enable two-factor authentication",
        avatarComingSoon: "Profile picture upload is coming soon.",
        uploadAvatar: "Upload profile picture",
        orgContext: {
          title: "My Organization",
          company: "Company",
          department: "Department",
          team: "Team",
          role: "Role",
          noInfo: "Not assigned yet",
        },
      },
      organization: {
        information: "Company information",
        members: "Team members",
        logoComingSoon: "Logo upload is coming soon.",
        uploadLogo: "Upload logo",
        summary: {
          size: "Company size",
          website: "Website",
          primaryColor: "Primary color",
        },
        fields: {
          name: "Company name",
          type: "Company type",
          size: "Company size",
          industry: "Industry",
          website: "Website",
          primaryColor: "Primary color",
        },
        types: {
          hospital: "Hospital",
          clinic: "Clinic",
          research: "Research institution",
          university: "University",
          pharma: "Pharmaceutical company",
          biotech: "Biotech company",
          other: "Other",
        },
        sizes: {
          "1-50": "1-50 employees",
          "51-200": "51-200 employees",
          "201-1000": "201-1000 employees",
          "1001-5000": "1001-5000 employees",
          "5000+": "5000+ employees",
        },
        roles: {
          admin: "Administrator",
          reviewer: "Reviewer",
          analyst: "Analyst",
          viewer: "Viewer",
          member: "Member",
          dept_admin: "Department Admin",
          team_admin: "Team Admin",
          data_steward: "Data Steward",
          guest: "Guest",
        },
        actions: {
          edit: "Edit",
          remove: "Remove",
        },
        dialog: {
          title: "Add new team member",
          description: "Enter the email address of the user. They must already have an Argus account.",
          email: "Email address",
          role: "Role",
        },
        teamHint: {
          title: "Team members",
          description: "{{count}} member(s) in your company",
          goToTeam: "Go to Team",
        },
        noOrgYet: "No company created yet.",
        companyReadOnlyNote: "Company details are managed by your administrator and cannot be edited here.",
        accordion: {
          company: "Company",
          departments: "Departments",
          noDepartments: "No departments configured yet.",
          createDepartment: "Create Department",
          teams: "Teams",
          noTeams: "No teams configured yet.",
          createTeam: "Create Team",
          members: "Members",
          leaveTeam: "Leave team",
        },
      },
      team: {
        title: "Team members",
        subtitle: "{{count}} member(s) in your company",
        noMembers: "No members invited yet.",
        youLabel: "You",
        noOrg: {
          title: "No company yet",
          description: "Create a company first to invite members.",
          goToOrg: "Go to Company",
        },
        editRoleDialog: {
          title: "Edit role",
          description: "Change role for {{email}}",
        },
        removeConfirm: {
          title: "Remove member?",
          description: "Are you sure you want to remove {{name}} from the company?",
          confirm: "Remove",
        },
      },
      notifications: {
        emailTitle: "Email notifications",
        inAppTitle: "In-app notifications",
        items: {
          newRequests: {
            title: "New data requests",
            email: "Receive an email when new requests arrive",
            inApp: "Receive a notification when new requests arrive",
          },
          statusChanges: {
            title: "Status changes",
            email: "Receive an email when the status of your requests changes",
            inApp: "Receive a notification when the status of your requests changes",
          },
          messages: {
            title: "New messages",
            email: "Receive an email when you receive new messages",
            inApp: "Receive a notification when you receive new messages",
          },
          billing: {
            title: "Billing information",
            email: "Receive an email about billing and payments",
            inApp: "Receive a notification about billing and payments",
          },
          weeklyReport: {
            title: "Weekly report",
            email: "Receive a weekly report about your requests",
          },
        },
      },
      privacy: {
        privacyTitle: "Privacy settings",
        dataSharingTitle: "Data sharing",
        dataSharingDescription: "Define how much information about your requests is shared with partner clinics.",
        dataSharingOptions: {
          minimal: "Minimal - share only required data",
          standard: "Standard - share basic information",
          extended: "Extended - share detailed information",
        },
        anonymizeLabel: "Anonymize results",
        anonymizeDescription: "When enabled, all patient data in analysis results is automatically anonymized.",
        analyticsLabel: "Allow usage analytics",
        analyticsDescription: "Allow us to collect anonymized usage data to improve the service.",
        retentionTitle: "Retention period for request data",
        retentionDescription: "Define how long your request data should be stored.",
        retentionMarks: {
          months6: "6 months",
          year1: "1 year",
          years2: "2 years",
          years3: "3 years",
          years5: "5 years",
        },
      },
      security: {
        title: "Security settings",
        twoFactorTitle: "Two-factor authentication",
        statusEnabled: "Enabled",
        statusDisabled: "Disabled",
        enabledHelp: "Your sign-in is protected by a second factor.",
        disabledHelp: "Enable this option for additional security.",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmPassword: "Confirm new password",
        sessionManagement: "Session management",
        sessionHelp: "Ends all active sessions except the current one.",
        accessLogsTitle: "Activity logs",
        accessLogsDescription: "Review your account activity and security events.",
        accessLogsComingSoon: "Access logs are being prepared and not yet available.",
        accessLogsEmpty: "No activity logs yet.",
        refreshLogs: "Refresh logs",
        accessLogCols: {
          event: "Event",
          description: "Description",
          ip: "IP address",
          time: "Time",
        },
      },
      twoFa: {
        setupTitle: "Set up two-factor authentication",
        setupDescription: "Scan the QR code with your authenticator app (e.g. Google Authenticator or Authy), then enter the 6-digit code below.",
        manualEntryLabel: "Manual key (click to copy)",
        clickToCopy: "Copy to clipboard",
        secretCopied: "Secret copied.",
        codeLabel: "6-digit code",
        verifyButton: "Verify & enable",
        disableTitle: "Disable two-factor authentication",
        disableDescription: "Are you sure you want to disable two-factor authentication? Your account will be less secure.",
        disableButton: "Disable",
      },
      billing: {
        currentPlan: "Current plan",
        nextBilling: "Next billing:",
        paymentMethod: "Payment method:",
        institutionNumber: "Institution number:",
        invoiceHistory: "Invoice history",
        invoiceId: "Invoice ID",
        date: "Date",
        amount: "Amount",
        status: "Status",
        actions: "Actions",
        billingAddress: "Billing address",
        contactPerson: "Contact person",
        invoiceEmail: "Billing email",
        vatId: "VAT ID",
        paid: "paid",
      },
      api: {
        settingsTitle: "API settings",
        enableAccess: "Enable API access",
        enableAccessDescription: "Allows access to ARGUS data through the API.",
        apiKey: "API key",
        newKeyWarning: "Warning: Generating a new key invalidates the old one.",
        toggleKeyVisibility: "Show or hide API key",
        copyKey: "Copy API key",
        rateLimit: "Rate limit",
        rateLimitDescription: "Maximum number of API requests per hour.",
        requestsPerHour: "requests/hour",
        webhookTitle: "Webhook configuration",
        webhookDescription: "Configure webhooks to receive notifications about events.",
        webhookUrl: "Webhook URL",
        webhookEvents: "Events",
        analysisResults: "New analysis results",
        statusChanges: "Status changes",
        messages: "New messages",
        ipWhitelist: "IP whitelist",
        ipWhitelistDescription: "Restrict API access to specific IP addresses.",
        newIpAddress: "New IP address",
        newIpPlaceholder: "e.g. 192.168.1.1",
        aiProvider: {
          title: "AI provider",
          description: "Provider, model ID and (for local models) endpoint for AI-powered features. The suggestion list is a helper, not a restriction -- any model ID can be entered freely.",
          fields: {
            provider: "Provider",
            providerPlaceholder: "e.g. OpenRouter",
            model: "Model ID",
            modelPlaceholder: "e.g. claude-sonnet-5",
            endpoint: "Endpoint",
          },
        },
        llmModels: {
          title: "LLM models",
          description: "Models with their own API key for this instance. The key is only ever sent -- never read back, never displayed.",
          columns: {
            provider: "Provider",
            model: "Model ID",
            label: "Label",
            status: "Status",
            credential: "Key",
            actions: "Actions",
          },
          status: {
            active: "Active",
            inactive: "Inactive",
          },
          credential: {
            present: "Key on file",
            missing: "No key on file",
          },
          empty: "No models added yet.",
          addTitle: "Add model",
          fields: {
            provider: "LLM provider",
            model: "LLM model ID",
            label: "Label",
            apiKey: "API key",
          },
          deleteAction: "Delete model",
          deleteTitle: "Delete model",
          deleteConfirm: "Do you really want to delete \"{{label}}\"? The stored key will be removed along with it.",
          deleteButton: "Delete",
          testConnection: "Test connection",
          testing: "Testing connection...",
          testSuccess: "Successful ({{latency}} ms)",
          testError: "Failed{{message}}",
          loadError: "Models could not be loaded.",
          saveError: "Model could not be saved.",
          deleteError: "Model could not be deleted.",
        },
        integrations: "Integrations",
        integrationsCards: {
          rStudio: "Connect the ARGUS platform with R Studio for automated data analyses.",
          python: "Use Python libraries for automated data analysis and result preparation.",
          tableau: "Create dashboards to visualize requests and analysis statistics.",
        },
      },
      appearance: {
        title: "Appearance",
        theme: "Color scheme",
        themes: {
          light: "Light",
          dark: "Dark",
          system: "System",
        },
        primaryColor: "Primary color",
        fontSize: "Font size",
        fontScale: {
          small: "Small",
          normal: "Normal",
          large: "Large",
        },
        animations: "Animations",
        animationsEnabled: "Enable animations",
        languageRegion: "Language and region",
        switchLanguage: "Switch language",
        dateFormat: "Date format",
        timeZone: "Time zone",
        timeZones: {
          berlin: "Europe/Berlin (GMT+1)",
          london: "Europe/London (GMT)",
          newYork: "America/New York (GMT-5)",
          tokyo: "Asia/Tokyo (GMT+9)",
        },
        dashboard: "Dashboard settings",
        defaultHomepage: "Default start page",
        homepageOptions: {
          dashboard: "Dashboard",
          requests: "Incoming requests",
          negotiations: "Negotiations",
          executions: "Executions",
        },
        widgets: {
          title: "Dashboard widgets",
          incomingRequests: "Incoming requests",
          statistics: "Statistics",
          runningAnalyses: "Running analyses",
          paymentOverview: "Payment overview",
          activityLog: "Activity log",
        },
      },
    },
    snackbars: {
      authRequired: "Error: Not signed in",
      noOrganization: "Error: No company found",
      orgNameRequired: "Please enter a company name.",
      emailRequired: "Please enter an email address.",
      profileSaved: "Profile settings saved successfully.",
      organizationCreated: "Company created successfully.",
      organizationSaved: "Company settings saved successfully.",
      notificationsSaved: "Notification settings saved successfully.",
      privacySaved: "Privacy and security settings saved successfully.",
      apiSaved: "API settings saved successfully.",
      appearanceSaved: "Appearance settings saved successfully.",
      genericSaved: "{{section}} settings saved successfully.",
      saveError: "Error while saving: {{message}}",
      addMemberSuccess: "Team member added successfully.",
      addMemberNotFound: "No Argus account found with that email address.",
      addMemberError: "Error while adding member: {{message}}",
      removeMemberSuccess: "Team member removed.",
      removeMemberError: "Error while removing member: {{message}}",
      memberRoleUpdated: "Member role updated successfully.",
      memberRoleUpdateError: "Error updating role: {{message}}",
      apiKeyGenerated: "A new API key was generated and saved.",
      apiKeyGenerateError: "Failed to generate API key: {{message}}",
      duplicateIp: "This IP address already exists.",
      invalidIp: "Invalid IP address format. Use e.g. 192.168.1.1 or 10.0.0.0/24.",
      oldPasswordRequired: "Please enter your current password.",
      passwordTooShort: "New password must be at least 8 characters.",
      passwordMismatch: "New password and confirmation do not match.",
      sessionEnded: "All other sessions have been ended.",
      sessionEndError: "Failed to end sessions: {{message}}",
      webhookTested: "Webhook test sent.",
      webhookTestError: "Webhook test failed: {{message}}",
      apiKeyCopied: "API key copied to clipboard.",
      avatarSaved: "Profile picture saved.",
      avatarSaveError: "Failed to save profile picture: {{message}}",
      logoSaved: "Logo saved.",
      logoSaveError: "Failed to save logo: {{message}}",
      invalidImageType: "Please select a valid image file.",
      imageTooLarge: "Image file must be at most 5 MB.",
      twoFaSetupError: "2FA setup failed: {{message}}",
      twoFaCodeRequired: "Please enter the 6-digit code from your authenticator app.",
      twoFaEnabled: "Two-factor authentication has been successfully enabled.",
      twoFaVerifyError: "Code verification failed: {{message}}",
      twoFaDisabled: "Two-factor authentication has been disabled.",
      twoFaDisableError: "Failed to disable 2FA: {{message}}",
    },
  },
  supportPage: {
    title: "Help & Documentation",
    subtitle: "Central help for the Olymp workflow: Data Catalog -> Cohort Builder -> Requests.",
    searchPlaceholder: "Search in help, workflow, FAQ, glossary, and contact...",
    tabAriaLabel: "Help and documentation tabs",
    chips: {
      gettingStarted: "Getting Started",
      workflow: "Workflow",
      faqs: "FAQs",
      glossary: "Glossary",
      contact: "Contact",
    },
    tabs: {
      gettingStarted: "Getting Started",
      workflow: "Workflow",
      faqs: "FAQs",
      glossary: "Glossary",
      contact: "Contact",
    },
    noResults: 'No results for "{{term}}". Try another search term.',
    sections: {
      gettingStartedTitle: "Getting Started",
      gettingStartedSubtitle:
        "Start with the end-to-end flow in three steps and navigate directly to the matching page.",
      workflowTitle: "Workflow Guides",
      workflowSubtitle: "Detailed guidance for Data Catalog, Cohort Builder, and Requests.",
      glossaryTitle: "Glossary",
      glossaryTerm: "Term",
      glossaryDefinition: "Definition",
      contactTitle: "Contact & Support",
      contactSubtitle: "For help, bug reports, and feature requests, use the channels below.",
    },
    content: {
      gettingStartedSteps: [
        {
          title: "1. Prepare data catalog",
          description: "Create List A (cohort parameters) and List B (extraction) to start your workflow cleanly.",
          actionLabel: "Go to Data Catalog",
          actionPath: "/catalog",
        },
        {
          title: "2. Build cohort",
          description: "Define and refine your population in Cohort Builder (list and graph view).",
          actionLabel: "Go to Cohort Builder",
          actionPath: "/cohorts",
        },
        {
          title: "3. Submit request",
          description: "Combine WHO (cohort) and WHAT (List B) and create a data request.",
          actionLabel: "Go to Requests",
          actionPath: "/requests",
        },
      ],
      workflowGuides: [
        {
          title: "Data Catalog",
          topics: [
            "Create and manage parameter lists",
            "List A = parameter input for inclusion/exclusion criteria in Cohort Builder",
            "List B = extraction fields for requests",
          ],
          path: "/catalog",
        },
        {
          title: "Cohort Builder",
          topics: [
            "Switch between list and graph view",
            "Create sub-cohorts for refinements",
            "Edit criteria and simulate execution",
          ],
          path: "/cohorts",
        },
        {
          title: "Requests",
          topics: [
            "Create request with cohort + List B",
            "Track status and progress",
            "Review and export results",
          ],
          path: "/requests",
        },
      ],
      faqItems: [
        {
          question: "What is the difference between List A and List B?",
          answer:
            "List A defines cohort parameters (WHO) that are used in Cohort Builder to define cohort criteria. List B defines the data fields to extract (WHAT).",
        },
        {
          question: "How do I switch between list and graph view?",
          answer: "In Cohort Builder, use the top toggle to switch between list and graph view.",
        },
        {
          question: "How long does a data request take?",
          answer: "It depends on data scope and cohort complexity. Request status is shown transparently.",
        },
      ],
      glossaryItems: [
        { term: "Cohort", definition: "Defined patient group with specific criteria." },
        { term: "Sub-Cohort", definition: "Refined subset of a parent cohort." },
        { term: "Cohort Builder", definition: "Tool to create and maintain hierarchical cohorts." },
        { term: "Graph View", definition: "Interactive node view of the cohort structure." },
        { term: "List View", definition: "Table view to manage cohorts." },
        { term: "List A", definition: "Parameter list used in Cohort Builder to define inclusion/exclusion criteria." },
        { term: "List B", definition: "Parameter list for data extraction in requests." },
      ],
      contactItems: [
        {
          title: "Support Email",
          description: "Get support from our team for questions and problems.",
          value: "support@argus-health.de",
          href: "mailto:support@argus-health.de",
        },
        {
          title: "Bug Report",
          description: "Capture technical issues directly as a ticket.",
          value: "Create issue in GitLab",
          href: "https://gitlab.it.argus-evaluation.com/argus/applications/argus-platform/-/issues/new",
        },
        {
          title: "Feature Request",
          description: "Document workflow improvement ideas.",
          value: "Suggest new feature",
          href: "https://gitlab.it.argus-evaluation.com/argus/applications/argus-platform/-/issues/new",
        },
      ],
    },
  },
});

mergeDeep(resources.de.translation, {
  cohorts: {
    table: {
      name: "Name",
    },
    builder: {
      step1Title: "1. Parameterliste auswählen",
      step1Description: "Wählen Sie eine Parameterliste aus, um die verfügbaren Parameter in den Builder zu laden.",
      parameterListLabel: "Parameterliste",
      parametersCount: "{{count}} Parameter",
      listDetails: "Listendetails",
      createdAt: "Erstellt: {{date}}",
      createdBy: "Von: {{user}}",
      loadListAndContinue: "Liste laden und weiter",
      infoTitle: "Kohorteninformationen",
      nameLabel: "Name der Kohorte",
      namePlaceholder: "z. B. Sepsis-Patienten mit Hypotonie",
      descriptionLabel: "Beschreibung",
      descriptionPlaceholder: "Beschreiben Sie Ziel und Kriterien dieser Kohorte",
      visibility: {
        publicTitle: "Öffentlich",
        publicHint: "Für alle Nutzer sichtbar",
        privateTitle: "Privat",
        privateHint: "Nur für Sie sichtbar",
      },
      availableParameters: "Verfügbare Parameter",
      loadedCount: "{{count}} geladen",
      searchPlaceholder: "Parameter suchen...",
      onlyUnused: "Nur ungenutzte",
      showAll: "Alle anzeigen",
      usedCount: "{{count}} verwendet",
      noneFound: "Keine passenden Parameter gefunden.",
      includeButton: "Ein",
      excludeButton: "Aus",
      includeTitle: "Einschlusskriterien",
      includeEmpty: "Fügen Sie links Parameter hinzu, um Einschlusskriterien zu definieren.",
      excludeTitle: "Ausschlusskriterien",
      excludeEmpty: "Keine Ausschlusskriterien definiert.",
      operators: {
        operatorLabel: "Operator",
        valueLabel: "Wert",
        connectorLabel: "Verknüpfung",
        and: "UND",
        or: "ODER",
      },
      saveCohort: "Kohorte speichern",
      validation: {
        selectParameterList: "Bitte wählen Sie zuerst eine Parameterliste aus.",
        enterName: "Bitte geben Sie einen Kohortennamen ein.",
        enterDescription: "Bitte geben Sie eine Beschreibung ein.",
        addInclusion: "Bitte definieren Sie mindestens ein Einschlusskriterium.",
        fillAllValues: "Bitte füllen Sie alle Bedingungswerte aus.",
      },
    },
  },
  dataCatalogHelp: {
    listA: {
      examples: ["Alter > 65", "Diagnose: Lungenkrebs", "Blutdruck < 90 mmHg"],
    },
    listB: {
      examples: ["Herzfrequenz", "Hämoglobin", "Medikationshistorie"],
    },
    workflowSteps: {
      catalog: "1. Datenkatalog",
      cohorts: "2. Cohort Builder",
      requests: "3. Anfragen",
    },
  },
  requests: {
    messages: {
      dataStewardTeam: "Data Steward Team",
    },
  },
  supportPage: {
    actions: {
      openSection: "Bereich öffnen",
    },
    sections: {
      faqTitle: "Häufige Fragen (FAQ)",
    },
  },
});

mergeDeep(resources.en.translation, {
  cohorts: {
    table: {
      name: "Name",
    },
    builder: {
      step1Title: "1. Select parameter list",
      step1Description: "Select a parameter list to load available parameters into the builder.",
      parameterListLabel: "Parameter list",
      parametersCount: "{{count}} parameters",
      listDetails: "List details",
      createdAt: "Created: {{date}}",
      createdBy: "By: {{user}}",
      loadListAndContinue: "Load list and continue",
      infoTitle: "Cohort information",
      nameLabel: "Cohort name",
      namePlaceholder: "e.g. Sepsis patients with hypotension",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Describe purpose and criteria of this cohort",
      visibility: {
        publicTitle: "Public",
        publicHint: "Visible to all users",
        privateTitle: "Private",
        privateHint: "Visible only to you",
      },
      availableParameters: "Available parameters",
      loadedCount: "{{count}} loaded",
      searchPlaceholder: "Search parameters...",
      onlyUnused: "Only unused",
      showAll: "Show all",
      usedCount: "{{count}} used",
      noneFound: "No matching parameters found.",
      includeButton: "Include",
      excludeButton: "Exclude",
      includeTitle: "Inclusion criteria",
      includeEmpty: "Add parameters on the left to define inclusion criteria.",
      excludeTitle: "Exclusion criteria",
      excludeEmpty: "No exclusion criteria defined.",
      operators: {
        operatorLabel: "Operator",
        valueLabel: "Value",
        connectorLabel: "Connector",
        and: "AND",
        or: "OR",
      },
      saveCohort: "Save cohort",
      validation: {
        selectParameterList: "Please select a parameter list first.",
        enterName: "Please enter a cohort name.",
        enterDescription: "Please enter a description.",
        addInclusion: "Please add at least one inclusion criterion.",
        fillAllValues: "Please fill all condition values.",
      },
    },
  },
  dataCatalogHelp: {
    listA: {
      examples: ["Age > 65", "Diagnosis: Lung Cancer", "Blood Pressure < 90 mmHg"],
    },
    listB: {
      examples: ["Heart Rate", "Hemoglobin", "Medication History"],
    },
    workflowSteps: {
      catalog: "1. Data Catalog",
      cohorts: "2. Cohort Builder",
      requests: "3. Requests",
    },
  },
  requests: {
    messages: {
      dataStewardTeam: "Data Steward Team",
    },
  },
  supportPage: {
    actions: {
      openSection: "Open section",
    },
    sections: {
      faqTitle: "Frequently Asked Questions (FAQ)",
    },
  },
});

mergeDeep(resources.de.translation, {
  dataCatalog: {
    status: {
      loading: "Lade Katalogdaten aus der API...",
      loadedFromApi: "Katalog aus API geladen — {{count}} Parameter",
      apiUnavailable: "Katalog-API nicht erreichbar. Es wird kein lokaler Fallback verwendet.",
      authRequired: "Die Sitzung ist nicht mehr gültig. Bitte erneut anmelden.",
      filtersPartiallyAvailable:
        "Katalogfilter sind nur teilweise verfügbar, weil Tag- oder Stationsmetadaten nicht aus der API geladen werden konnten.",
      detailLoading: "Lade Detaildaten aus dem Backend...",
      detailLoadFailed: "Detaildaten konnten nicht geladen werden.",
      aiSuggestionsUnavailable: "Der KI-Assistent ist noch nicht angebunden. Es werden keine Parameter vorgeschlagen.",
      setApplied: 'Set "{{name}}" wurde angewendet',
    },
    table: {
      // Leerstelle statt Rueckfall (#246): ohne Zuordnung wird nicht der lokale
      // Name als OMOP-Konzept ausgegeben, sondern diese Markierung.
      notMapped: "keine OMOP-Zuordnung",
      profiledAt: "Profiling vom {{date}}",
      localNameHint: "lokal: {{name}}",
      columns: {
        parameter: "Parameter",
        tags: "Tags",
        frequency: "Häufigkeit",
        omopStatus: "OMOP-Status",
        openehrStatus: "openEHR-Status",
        sensitivity: "Sensitivität",
        actions: "Aktionen",
      },
      tooltips: {
        local: "Lokal",
        omop: "OMOP",
        code: "Code",
        vocabulary: "Vokabular",
        multipleUnits: "Mehrere Einheiten: {{units}}",
        unitsCount: "{{count}} Einheiten",
        createdBy: "Erstellt von: {{user}}",
        viewAllDetails: "Alle Details anzeigen",
      },
    },
    actions: {
      addToFavorites: "Zu Favoriten hinzufügen",
      removeFromFavorites: "Von Favoriten entfernen",
      addToLists: "Zu Listen hinzufügen",
      inLists: "In Listen",
      addToListNamed: "Zu Liste hinzufügen: {{list}}",
      addToListA: "Zu Liste A hinzufügen: {{list}}",
      addToListB: "Zu Liste B hinzufügen: {{list}}",
      inListClickRemove: 'In Liste: {{list}} (Klicken zum Entfernen)',
      inListAClickRemove: 'In Liste A: {{list}} (Klicken zum Entfernen)',
      inListBClickRemove: 'In Liste B: {{list}} (Klicken zum Entfernen)',
    },
    filterBar: {
      searchPlaceholder: 'Parameter suchen... (z.B. "Blutdruck", "Beatmung", "Labor")',
      sets: "Sets",
      savedFilterCombinations: "Gespeicherte Filter-Kombinationen",
      noSetsAvailable: "Keine Sets verfügbar",
      addFilter: "Filter hinzufügen",
      aiAssistant: "KI-Assistent",
      resetAll: "Alle zurücksetzen",
      activeFilters: "Aktive Filter ({{count}}):",
      sensitivityFilter: "Sensitivität: {{value}}",
      omopFilter: "OMOP: {{value}}",
      openehrFilter: "openEHR: {{value}}",
      archetypeFilter: "Archetyp: {{value}}",
      nameView: {        local: "Lokal",
        omop: "OMOP",
        localTooltip: "Zeige lokale Namen als Hauptname",
        omopTooltip: "Zeige die OMOP-Zuordnung; die Liste zeigt dann nur zugeordnete Parameter",
        openehr: "openEHR",
        openehrTooltip: "Zeige die openEHR-Zuordnung (Archetyp und AQL-Pfad); die Liste zeigt dann nur zugeordnete Parameter",
        alle: "Alle",
        alleTooltip: "Zeige beide Zuordnungen nebeneinander, ohne Einschränkung",
        ariaLabel: "Ansicht: lokal, OMOP, openEHR oder alle",
      },
    },
    filterPanel: {
      selectType: "Wähle einen Filter-Typ aus:",
      activeCount: "{{count}} aktiv",
      statusCount: "({{count}})",
      filterTypes: {
        categories: "Kategorien",
        stations: "Stationen / Abteilungen",
        sourceSystems: "IT-Systeme",
        sensitivity: "Sensitivität",
        omop: "OMOP-Status",
        openehr: "openEHR-Status",
      },
      categoriesHelp: "Wähle Kategorien aus, um Parameter nach Themengebieten zu filtern.",
      categoriesSearch: "Kategorien suchen...",
      presetSets: "Vorgefertigte Sets:",
      popularCategories: "Beliebte Kategorien:",
      manageCategories: "Kategorien verwalten",
      stationsHelp: "Wähle Stationen/Abteilungen aus, um Parameter nach Standort zu filtern.",
      stationsSearch: "Stationen suchen...",
      popularStations: "Häufig verwendet:",
      sourceSystemsHelp: "Wähle IT-Systeme aus, um Parameter nach Datenquelle zu filtern.",
      sourceSystemsSearch: "IT-Systeme suchen...",
      availableSourceSystems: "Verfügbare IT-Systeme:",
      sensitivityHelp: "Filtere Parameter nach Datensensitivität und Zugriffslevel.",
      omopHelp: "Filtere Parameter nach OMOP-Mapping-Status.",
      zugeordnet: "zugeordnet",
      zugeordnetBeschreibung: "Nur Parameter, die in dieser Darstellung eine Zuordnung haben",
      erzwungen: "Die Ansicht schränkt die Liste bereits ein. Für eine freie Auswahl auf „Alle“ umschalten.",
      openehrHelp: "Nach dem Stand der openEHR-Zuordnung filtern. Zusammen mit dem OMOP-Status findet sich damit der Fall, den openEHR führt und OMOP nicht.",
      openehrOptions: {
        validated: { description: "Archetyp und AQL-Pfad sind geprüft" },
        suggested: { description: "Zuordnung vorgeschlagen, noch nicht geprüft" },
        notMapped: { description: "Keine openEHR-Zuordnung hinterlegt" },
      },
      all: "Alle",
      noRestriction: "Keine Einschränkung",
      sensitivityOptions: {
        plain: {
          label: "Plain",
          description: "Unverschlüsselte Originaldaten",
        },
        pseudonymized: {
          description: "IDs ersetzt, re-identifizierbar",
        },
        anonymized: {
          description: "Vollständig anonymisiert",
        },
      },
      omopOptions: {
        validated: {
          description: "OMOP-Mapping bestätigt",
        },
        suggested: {
          description: "KI-Vorschlag, nicht validiert",
        },
        notMapped: {
          description: "Kein OMOP-Mapping vorhanden",
        },
      },
    },
    frequency: {
      sectionTitle: "Verfügbarkeit & Häufigkeits-Analyse",
      availableSince: "Verfügbar seit {{date}}",
      coverage: "Verbreitung",
      stationAreas: "{{count}} Stationsbereiche",
      noStationData: "Keine Stationsdaten",
      moreAreas: "... weitere {{count}} Bereiche",
      noDataAvailable: "Keine Daten verfügbar",
      caseCoverage: "Fallabdeckung",
      allCases: "{{value}}% aller Fälle",
      casesOfTotal: "{{cases}} von {{total}} Fällen",
      noCaseData: "Keine Falldaten",
      volume: "Messumfang",
      averagePerCase: "Durchschnitt pro Fall",
      measurementsAverage: "⌀ {{value}} Messungen",
      median: "Median: {{value}}",
      noMeasurementData: "Keine Messdaten",
      total: "Gesamt",
      measurementsLastYear: "Messungen (letztes Jahr)",
      pattern: "Messmuster",
      typicalFrequency: "Typische Frequenz",
      interval: "⌀ {{value}} Intervall",
      continuousMeasurements: "Kontinuierliche Messungen",
      continuousCases: "{{count}} Fälle mit >10 Messungen",
      noData: "Keine Daten",
      cases: "Fälle",
      stations: "Stationen",
      suppressed: "Unterdrückt",
      suppressedExplanation: "Wert unterdrückt: Fallzahl unterhalb der Anonymisierungsschwelle.",
      suppressedExplanationWithThreshold: "Wert unterdrückt: Fallzahl unter der Schwelle von {{threshold}}.",
      profilingSummary: "Profiling vom {{date}}: {{totalMeasurements}} Messungen in {{casesWithParameter}} von {{totalCases}} Aufnahmen.",
      profilingSuppressionNote: "Aggregate unter {{threshold}} Fällen sind unterdrückt, nicht gerundet.",
      stationGroups: {
        icu: "Intensivstationen",
        imc: "IMC (Intermediate Care)",
        ward: "Normalstationen",
        opDiagnostics: "OP & Diagnostik",
        lab: "Labor",
        other: "Sonstige",
      },
    },
    expanded: {
      unitsAndSources: "Einheiten & Datenquellen",
      unitMeasurements: "{{count}} Messungen",
      unitNotRecorded: "(nicht erfasst)",
      valueDistribution: "Werteverteilung",
      valueDistributionOther: "sonstige",
      valueDistributionEmpty: "(ohne Angabe)",
      valueDistributionCount: "{{count}} Messungen",
      valueDistributionNotAvailable: "Keine Werteverteilung",
      // Kurzform im aufgeklappten Bereich (#244): die ganze Liste steht im
      // Detail-View, hier stehen die haeufigsten Werte plus diese Zeile --
      // damit die Kurzform nicht wie eine vollstaendige Liste aussieht.
      valueDistributionMore: "{{count}} weitere Werte im Detail",
      valueStatistics: "Wertestatistik",
      median: "Median",
      iqr: "Quartilsabstand",
      range: "Spannweite",
      valueStatisticsHint: "Vollstaendige Verteilung im Detail",
      valueStatisticsRestricted: "Eingeschraenkt: {{percentage}} % der Werte ohne erfasste Einheit",
      stdev: "Standardabweichung",
      valueHistogram: "Verteilung der Messwerte",
      histogramClasses: "{{count}} Klassen",
      // Ausreisser-Hinweis (#252). Kein Urteil ueber die Werte: ein Ausreisser
      // ist keine Fehlmessung. Eine Herzfrequenz von 157 ist plausibel, eine
      // von 0 kann Asystolie sein.
      outlierPoint: "ausserhalb des Tukey-Zauns",
      outlierHint: "Extremwerte liegen ausserhalb des Tukey-Zauns ({{unten}} bis {{oben}})",
      standard: "Standard",
      noteLabel: "Hinweis:",
      normalizationNotice:
        "Beim Import in die OMOP-Datenbank werden alle Werte in die Standard-Einheit {{unit}} konvertiert.",
      omopMapping: "OMOP Mapping",
      openehrMapping: "openEHR-Zuordnung",
      codeLabel: "Code:",
      omopId: "OMOP ID: {{id}}",
      athenaOpen: "ATHENA öffnen",
      noMapping: "Kein Mapping vorhanden",
      addToList: "Zu Liste",
      list: "Liste",
      allDetails: "Alle Details",
    },
    mapping: {
      databaseMapping: "Datenbank-Mapping",
      originalName: "Name in der Quelle",
      sourceCode: "Code {{code}}",
      definition: "Definition",
      measurements: "Messwerte",
      copied: "Kopiert!",
      copyTableName: "Tabellenname kopieren",
      copyJoin: "Join kopieren",
    },
    sensitivity: {
      levels: {
        offen: "Offen",
        pseudonymisiert: "Pseudonymisiert",
        anonymisiert: "Anonymisiert",
        vertraulich: "Vertraulich",
        strictlyConfidential: "Streng vertraulich",
      },
      tooltips: {
        offen: "Keine Einschränkungen",
        pseudonymisiert: "Personenidentifizierende Daten wurden entfernt",
        anonymisiert: "Vollständig anonymisiert",
        vertraulich: "Zugriff nur mit besonderer Genehmigung",
        strictlyConfidential: "Höchste Vertraulichkeitsstufe",
      },
    },
    // Die zweite Darstellung (#772). Gleiches Statusvokabular wie OMOP --
    // `omopStatus` oben wird fuer beide benutzt, bewusst kein zweites.
    openehr: {
      keinArchetyp: "kein Archetyp hinterlegt",
      nichtInOmopAbbildbar: "in OMOP nicht abbildbar",
      abbildbarkeitUnbekannt: "Abbildbarkeit nach OMOP nicht geprüft",
      fragmentierung: "auf {{anzahl}} OMOP-Datensätze verteilt",
      aqlPfade: "AQL-Pfade",
      entsprichtOmop: "entspricht OMOP {{code}}",
      // #788: Bucket-Beschriftung der Archetyp-Chips fuer Parameter ohne
      // openEHR-Zuordnung (leerer `openehrName`).
      archetypOhneZuordnung: "ohne Zuordnung",
    },
    omopStatus: {
      validated: "Validiert",
      suggested: "Vorgeschlagen",
      notMapped: "Nicht gemappt",
      unknown: "Unbekannt",
    },
    // Herkunft einer Zuordnung (#257) -- eigene Achse neben `omopStatus`:
    // importiert, KI-Vorschlag (ungeprueft) oder vom Menschen validiert.
    mappingProvenance: {
      validated: "Vom Menschen validiert",
      import: "Importiert",
      ai: "KI-Vorschlag",
      user: "Manuell zugeordnet",
      manual: "Manuell zugeordnet",
      system: "Systemzuordnung",
      unvalidatedHint: "Nicht geprüft",
      detailHeading: "Herkunft",
      importedFrom: "Quelle: {{collection}} ({{license}})",
      importedFromNoLicense: "Quelle: {{collection}}",
      importedLicenseOnly: "Lizenz: {{license}}",
      filterLabel: "Nur ungeprüfte KI-Vorschläge",
      filterHelp: "Zeigt nur Karten, die die KI vorgeschlagen hat und die noch niemand geprüft hat.",
    },
    listComparison: {
      all: "Alle ({{count}})",
      onlyA: "Nur A: {{list}} ({{count}})",
      onlyB: "Nur B: {{list}} ({{count}})",
      both: "A ∩ B ({{count}})",
      neither: "Keine ({{count}})",
      neitherUnknown: "Keine (unbekannt)",
    },
  },
});

mergeDeep(resources.en.translation, {
  dataCatalog: {
    status: {
      loading: "Loading catalog data from API...",
      loadedFromApi: "Catalog loaded from API — {{count}} parameters",
      apiUnavailable: "Catalog API not reachable. No local fallback is used.",
      authRequired: "Your session is no longer valid. Please sign in again.",
      filtersPartiallyAvailable:
        "Catalog filters are only partially available because tag or station metadata could not be loaded from the API.",
      detailLoading: "Loading detail data from backend...",
      detailLoadFailed: "Detail data could not be loaded.",
      aiSuggestionsUnavailable: "The AI assistant is not connected yet. No parameters are suggested.",
      setApplied: 'Applied set "{{name}}"',
    },
    table: {
      notMapped: "no OMOP mapping",
      profiledAt: "Profiled on {{date}}",
      localNameHint: "local: {{name}}",
      columns: {
        parameter: "Parameter",
        tags: "Tags",
        frequency: "Frequency",
        omopStatus: "OMOP status",
        openehrStatus: "openEHR status",
        sensitivity: "Sensitivity",
        actions: "Actions",
      },
      tooltips: {
        local: "Local",
        omop: "OMOP",
        code: "Code",
        vocabulary: "Vocabulary",
        multipleUnits: "Multiple units: {{units}}",
        unitsCount: "{{count}} units",
        createdBy: "Created by: {{user}}",
        viewAllDetails: "View all details",
      },
    },
    actions: {
      addToFavorites: "Add to favorites",
      removeFromFavorites: "Remove from favorites",
      addToLists: "Add to lists",
      inLists: "In lists",
      addToListNamed: "Add to list: {{list}}",
      addToListA: "Add to list A: {{list}}",
      addToListB: "Add to list B: {{list}}",
      inListClickRemove: 'In list: {{list}} (click to remove)',
      inListAClickRemove: 'In list A: {{list}} (click to remove)',
      inListBClickRemove: 'In list B: {{list}} (click to remove)',
    },
    filterBar: {
      searchPlaceholder: 'Search parameters... (e.g. "Blutdruck", "Beatmung", "Labor")',
      sets: "Sets",
      savedFilterCombinations: "Saved filter combinations",
      noSetsAvailable: "No sets available",
      addFilter: "Add filter",
      aiAssistant: "AI assistant",
      resetAll: "Reset all",
      activeFilters: "Active filters ({{count}}):",
      sensitivityFilter: "Sensitivity: {{value}}",
      omopFilter: "OMOP: {{value}}",
      openehrFilter: "openEHR: {{value}}",
      archetypeFilter: "Archetype: {{value}}",
      nameView: {        local: "Local",
        omop: "OMOP",
        localTooltip: "Show local names as primary names",
        omopTooltip: "Show the OMOP mapping; the list then shows mapped parameters only",
        openehr: "openEHR",
        openehrTooltip: "Show the openEHR mapping (archetype and AQL path); the list then shows mapped parameters only",
        alle: "All",
        alleTooltip: "Show both mappings side by side, without restriction",
        ariaLabel: "View: local, OMOP, openEHR or all",
      },
    },
    filterPanel: {
      selectType: "Choose a filter type:",
      activeCount: "{{count}} active",
      statusCount: "({{count}})",
      filterTypes: {
        categories: "Categories",
        stations: "Stations / Departments",
        sourceSystems: "IT systems",
        sensitivity: "Sensitivity",
        omop: "OMOP status",
        openehr: "openEHR status",
      },
      categoriesHelp: "Select categories to filter parameters by topic.",
      categoriesSearch: "Search categories...",
      presetSets: "Preset sets:",
      popularCategories: "Popular categories:",
      manageCategories: "Manage categories",
      stationsHelp: "Select stations/departments to filter parameters by location.",
      stationsSearch: "Search stations...",
      popularStations: "Frequently used:",
      sourceSystemsHelp: "Select IT systems to filter parameters by data source.",
      sourceSystemsSearch: "Search IT systems...",
      availableSourceSystems: "Available IT systems:",
      sensitivityHelp: "Filter parameters by data sensitivity and access level.",
      omopHelp: "Filter parameters by OMOP mapping status.",
      zugeordnet: "mapped",
      zugeordnetBeschreibung: "Only parameters that have a mapping in this representation",
      erzwungen: "The current view already restricts the list. Switch to \"All\" to filter freely.",
      openehrHelp: "Filter by the state of the openEHR mapping. Combined with the OMOP status this finds the case openEHR carries and OMOP does not.",
      openehrOptions: {
        validated: { description: "Archetype and AQL path are validated" },
        suggested: { description: "Mapping suggested, not yet validated" },
        notMapped: { description: "No openEHR mapping recorded" },
      },
      all: "All",
      noRestriction: "No restriction",
      sensitivityOptions: {
        plain: {
          label: "Plain",
          description: "Unencrypted raw data",
        },
        pseudonymized: {
          description: "IDs replaced, re-identifiable",
        },
        anonymized: {
          description: "Fully anonymized",
        },
      },
      omopOptions: {
        validated: {
          description: "OMOP mapping confirmed",
        },
        suggested: {
          description: "AI suggestion, not validated",
        },
        notMapped: {
          description: "No OMOP mapping available",
        },
      },
    },
    frequency: {
      sectionTitle: "Availability & Frequency Analysis",
      availableSince: "Available since {{date}}",
      coverage: "Coverage",
      stationAreas: "{{count}} station areas",
      noStationData: "No station data",
      moreAreas: "... {{count}} more areas",
      noDataAvailable: "No data available",
      caseCoverage: "Case coverage",
      allCases: "{{value}}% of all cases",
      casesOfTotal: "{{cases}} of {{total}} cases",
      noCaseData: "No case data",
      volume: "Measurement volume",
      averagePerCase: "Average per case",
      measurementsAverage: "⌀ {{value}} measurements",
      median: "Median: {{value}}",
      noMeasurementData: "No measurement data",
      total: "Total",
      measurementsLastYear: "Measurements (last year)",
      pattern: "Measurement pattern",
      typicalFrequency: "Typical frequency",
      interval: "⌀ {{value}} interval",
      continuousMeasurements: "Continuous measurements",
      continuousCases: "{{count}} cases with >10 measurements",
      noData: "No data",
      cases: "Cases",
      stations: "Stations",
      suppressed: "Suppressed",
      suppressedExplanation: "Value suppressed: case count below the anonymization threshold.",
      suppressedExplanationWithThreshold: "Value suppressed: case count below the threshold of {{threshold}}.",
      profilingSummary: "Profiled on {{date}}: {{totalMeasurements}} measurements in {{casesWithParameter}} of {{totalCases}} admissions.",
      profilingSuppressionNote: "Aggregates below {{threshold}} cases are suppressed, not rounded.",
      stationGroups: {
        icu: "Intensive care units",
        imc: "IMC (Intermediate Care)",
        ward: "General wards",
        opDiagnostics: "OR & Diagnostics",
        lab: "Lab",
        other: "Other",
      },
    },
    expanded: {
      unitsAndSources: "Units & Data Sources",
      unitMeasurements: "{{count}} measurements",
      unitNotRecorded: "(not recorded)",
      valueDistribution: "Value distribution",
      valueDistributionOther: "other",
      valueDistributionEmpty: "(not stated)",
      valueDistributionCount: "{{count}} measurements",
      valueDistributionNotAvailable: "No value distribution",
      valueDistributionMore: "{{count}} more values in the detail view",
      valueStatistics: "Value statistics",
      median: "Median",
      iqr: "Interquartile range",
      range: "Range",
      valueStatisticsHint: "Full distribution in the detail view",
      valueStatisticsRestricted: "Restricted: {{percentage}} % of values have no recorded unit",
      stdev: "Standard deviation",
      valueHistogram: "Distribution of measured values",
      histogramClasses: "{{count}} classes",
      outlierPoint: "outside the Tukey fence",
      outlierHint: "Extreme values lie outside the Tukey fence ({{unten}} to {{oben}})",
      standard: "Standard",
      noteLabel: "Note:",
      normalizationNotice:
        "When importing into the OMOP database, all values are converted to the standard unit {{unit}}.",
      omopMapping: "OMOP Mapping",
      openehrMapping: "openEHR mapping",
      codeLabel: "Code:",
      omopId: "OMOP ID: {{id}}",
      athenaOpen: "Open ATHENA",
      noMapping: "No mapping available",
      addToList: "Add to list",
      list: "List",
      allDetails: "All details",
    },
    mapping: {
      databaseMapping: "Database mapping",
      originalName: "Name in the source",
      sourceCode: "Code {{code}}",
      definition: "Definition",
      measurements: "Measurements",
      copied: "Copied!",
      copyTableName: "Copy table name",
      copyJoin: "Copy join",
    },
    sensitivity: {
      levels: {
        offen: "Open",
        pseudonymisiert: "Pseudonymized",
        anonymisiert: "Anonymized",
        vertraulich: "Confidential",
        strictlyConfidential: "Strictly confidential",
      },
      tooltips: {
        offen: "No restrictions",
        pseudonymisiert: "Personally identifiable data has been removed",
        anonymisiert: "Fully anonymized",
        vertraulich: "Access only with special approval",
        strictlyConfidential: "Highest confidentiality level",
      },
    },
    // Die zweite Darstellung (#772). Gleiches Statusvokabular wie OMOP --
    // `omopStatus` oben wird fuer beide benutzt, bewusst kein zweites.
    openehr: {
      keinArchetyp: "no archetype recorded",
      nichtInOmopAbbildbar: "not representable in OMOP",
      abbildbarkeitUnbekannt: "mapping to OMOP not assessed",
      fragmentierung: "split across {{anzahl}} OMOP records",
      aqlPfade: "AQL paths",
      entsprichtOmop: "corresponds to OMOP {{code}}",
      archetypOhneZuordnung: "not assigned",
    },
    omopStatus: {
      validated: "Validated",
      suggested: "Suggested",
      notMapped: "Not mapped",
      unknown: "Unknown",
    },
    mappingProvenance: {
      validated: "Validated by a human",
      import: "Imported",
      ai: "AI suggestion",
      user: "Manually assigned",
      manual: "Manually assigned",
      system: "System assignment",
      unvalidatedHint: "Not reviewed",
      detailHeading: "Provenance",
      importedFrom: "Source: {{collection}} ({{license}})",
      importedFromNoLicense: "Source: {{collection}}",
      importedLicenseOnly: "License: {{license}}",
      filterLabel: "Only unreviewed AI suggestions",
      filterHelp: "Shows only cards the AI suggested that nobody has reviewed yet.",
    },
    listComparison: {
      all: "All ({{count}})",
      onlyA: "Only A: {{list}} ({{count}})",
      onlyB: "Only B: {{list}} ({{count}})",
      both: "A ∩ B ({{count}})",
      neither: "None ({{count}})",
      neitherUnknown: "None (unknown)",
    },
  },
});

const ptTranslation = deepClone(resources.en.translation);
mergeDeep(ptTranslation, {
  common: {
    language: {
      de: "Alemão",
      en: "Inglês",
      pt: "Português",
    },
    country: {
      de: "Alemanha",
      en: "Reino Unido",
      pt: "Portugal",
    },
  },
  layout: {
    nav: {
      navigation: "Navegação",
      general: "Geral",
    },
    menu: {
      home: "Início",
      catalog: "Catálogo de Dados",
      cohorts: "Coortes",
      requests: "Solicitações",
      settings: "Configurações",
      adminPanel: "Painel Admin",
      help: "Ajuda e Suporte",
    },
    support: {
      needHelp: "Precisa de ajuda?",
      contactSupport: "Contatar suporte",
    },
    language: {
      ariaLabel: "Trocar idioma",
      tooltip: "Idioma: {{language}}",
    },
  },
  login: {
    email: "E-mail",
    password: "Senha",
    signIn: "Entrar",
    signingIn: "Entrando...",
    failed: "Falha no login",
    genericError: "Ocorreu um erro",
  },
  dashboard: {
    hero: {
      title: "Bem-vindo ao Catálogo de Dados ARGUS Olymp",
      subtitle: "Descubra, analise e use seus dados de pesquisa clínica",
      catalogCta: "Pesquisar no catálogo",
      cohortsCta: "Gerenciar coortes",
      requestsCta: "Solicitações de dados",
    },
    onboarding: {
      title: "Bem-vindo ao Olymp",
      subtitle: "Um guia curto para o primeiro login.",
      intro: "O Olymp segue um fluxo simples: primeiro estruturar parâmetros, depois definir coortes e por fim solicitar dados.",
      primaryAction: "Começar no Catálogo de Dados",
      dismiss: "Depois",
      rememberTitle: "Importante para o fluxo",
      rememberText: "A Lista A define parâmetros de coorte que depois serão usados no Cohort Builder para montar critérios de inclusão e exclusão. A Lista B define quais dados serão extraídos em Solicitações.",
      steps: {
        catalog: {
          title: "Catálogo de Dados",
          description: "Crie duas listas: Lista A para parâmetros de coorte e Lista B para a extração posterior.",
          action: "Abrir Catálogo de Dados",
        },
        cohortBuilder: {
          title: "Construtor de Coorte",
          description: "Use os parâmetros da Lista A para definir critérios de inclusão e exclusão e refinar a coorte.",
          action: "Abrir Construtor de Coorte",
        },
        requests: {
          title: "Solicitações",
          description: "Combine a coorte final com a Lista B para enviar uma solicitação de dados.",
          action: "Abrir Solicitações",
        },
      },
    },
    loadError: "Nem todos os cartões puderam ser carregados. Os números exibidos podem estar incompletos.",
  },
  workflowGuide: {
    subtitle:
      "Catálogo de Dados -> Coortes -> Solicitações: primeiro crie duas listas (Lista A = parâmetros de coorte, Lista B = extração), depois defina os critérios da coorte no Cohort Builder usando a Lista A e então envie a solicitação.",
    learnMore: "Saiba mais",
    tip:
      "Dica: critérios são regras médicas (por exemplo idade > 65 ou código de diagnóstico). No <catalog>Catálogo de Dados</catalog>, crie primeiro a Lista A (parâmetros WHO) e a Lista B (WHAT), defina os critérios da coorte no <cohort>Cohort Builder</cohort> com a Lista A e, por fim, gere a extração em <request>Solicitações</request> com coorte + Lista B.",
    steps: {
      catalog: "Catálogo de Dados",
      cohorts: "Coortes",
      requests: "Solicitações",
    },
    tooltips: {
      catalog:
        "Etapa 1: crie duas listas de parâmetros. A Lista A guarda parâmetros de coorte (WHO) usados depois para definir critérios, e a Lista B guarda campos para extração posterior (WHAT).",
      cohorts:
        "Etapa 2: defina a coorte com a Lista A. Critérios são regras de inclusão/exclusão que determinam quais pacientes pertencem à população.",
      requests:
        "Etapa 3: combine a coorte final (WHO) com a Lista B (WHAT) para iniciar a solicitação de dados.",
    },
  },
  dataCatalog: {
    labels: {
      listAEnabled: "Lista A ativa:",
      listComparisonEnabled: "Comparação de listas ativa (A / B):",
    },
    title: "Catálogo de Dados",
    manageAllLists: "Gerenciar todas as listas",
    overviewDialogTitle: "Catálogo de Dados - Visão geral",
    overviewDialogWorkflow: "Fluxo: Data Catalog -> Cohort Builder -> Requests",
    status: {
      loading: "Carregando dados do catálogo pela API...",
      loadedFromApi: "Catálogo carregado pela API — {{count}} parâmetros",
      apiUnavailable: "A API do catálogo está indisponível. Nenhum fallback local é usado.",
      authRequired: "Sua sessão não é mais válida. Faça login novamente.",
      filtersPartiallyAvailable:
        "Os filtros do catálogo estão apenas parcialmente disponíveis porque as tags ou metadados de estação não puderam ser carregados pela API.",
      detailLoading: "Carregando dados detalhados do backend...",
      detailLoadFailed: "Não foi possível carregar os dados detalhados.",
      aiSuggestionsUnavailable: "O assistente de IA ainda não está conectado. Nenhum parâmetro é sugerido.",
      setApplied: 'Conjunto "{{name}}" aplicado',
    },
    table: {
      columns: {
        parameter: "Parâmetro",
        tags: "Tags",
        frequency: "Frequência",
        omopStatus: "Status OMOP",
        openehrStatus: "Estado openEHR",
        sensitivity: "Sensibilidade",
        actions: "Ações",
      },
      tooltips: {
        local: "Local",
        omop: "OMOP",
        code: "Código",
        vocabulary: "Vocabulário",
        multipleUnits: "Múltiplas unidades: {{units}}",
        unitsCount: "{{count}} unidades",
        createdBy: "Criado por: {{user}}",
        viewAllDetails: "Ver todos os detalhes",
      },
    },
    actions: {
      addToFavorites: "Adicionar aos favoritos",
      removeFromFavorites: "Remover dos favoritos",
      addToLists: "Adicionar às listas",
      inLists: "Em listas",
      addToListNamed: "Adicionar à lista: {{list}}",
      addToListA: "Adicionar à lista A: {{list}}",
      addToListB: "Adicionar à lista B: {{list}}",
      inListClickRemove: 'Na lista: {{list}} (clique para remover)',
      inListAClickRemove: 'Na lista A: {{list}} (clique para remover)',
      inListBClickRemove: 'Na lista B: {{list}} (clique para remover)',
    },
    filterBar: {
      searchPlaceholder: 'Pesquisar parâmetros... (ex.: "Blutdruck", "Beatmung", "Labor")',
      sets: "Conjuntos",
      savedFilterCombinations: "Combinações de filtro salvas",
      noSetsAvailable: "Nenhum conjunto disponível",
      addFilter: "Adicionar filtro",
      aiAssistant: "Assistente de IA",
      resetAll: "Redefinir tudo",
      activeFilters: "Filtros ativos ({{count}}):",
      sensitivityFilter: "Sensibilidade: {{value}}",
      omopFilter: "OMOP: {{value}}",
      openehrFilter: "openEHR: {{value}}",
      archetypeFilter: "Arquétipo: {{value}}",
      nameView: {        local: "Local",
        omop: "OMOP",
        localTooltip: "Mostrar nomes locais como nome principal",
        omopTooltip: "Mostrar o mapeamento OMOP; a lista mostra então apenas parâmetros mapeados",
        openehr: "openEHR",
        openehrTooltip: "Mostrar o mapeamento openEHR (arquétipo e caminho AQL); a lista mostra então apenas parâmetros mapeados",
        alle: "Todos",
        alleTooltip: "Mostrar ambos os mapeamentos lado a lado, sem restrição",
        ariaLabel: "Vista: local, OMOP, openEHR ou todos",
      },
    },
    filterPanel: {
      selectType: "Escolha um tipo de filtro:",
      activeCount: "{{count}} ativos",
      statusCount: "({{count}})",
      filterTypes: {
        categories: "Categorias",
        stations: "Estações / Departamentos",
        sourceSystems: "Sistemas de TI",
        sensitivity: "Sensibilidade",
        omop: "Status OMOP",
        openehr: "Estado openEHR",
      },
      categoriesHelp: "Selecione categorias para filtrar os parâmetros por tema.",
      categoriesSearch: "Pesquisar categorias...",
      presetSets: "Conjuntos predefinidos:",
      popularCategories: "Categorias populares:",
      manageCategories: "Gerenciar categorias",
      stationsHelp: "Selecione estações/departamentos para filtrar os parâmetros por local.",
      stationsSearch: "Pesquisar estações...",
      popularStations: "Mais usados:",
      sourceSystemsHelp: "Selecione sistemas de TI para filtrar os parâmetros por fonte de dados.",
      sourceSystemsSearch: "Pesquisar sistemas de TI...",
      availableSourceSystems: "Sistemas de TI disponíveis:",
      sensitivityHelp: "Filtre parâmetros por sensibilidade dos dados e nível de acesso.",
      omopHelp: "Filtre parâmetros por status do mapeamento OMOP.",
      zugeordnet: "mapeado",
      zugeordnetBeschreibung: "Apenas parâmetros com mapeamento nesta representação",
      erzwungen: "A vista já restringe a lista. Mude para \"Todos\" para filtrar livremente.",
      openehrHelp: "Filtrar pelo estado do mapeamento openEHR. Em conjunto com o estado OMOP encontra-se o caso que o openEHR tem e o OMOP não.",
      openehrOptions: {
        validated: { description: "Arquétipo e caminho AQL verificados" },
        suggested: { description: "Mapeamento sugerido, ainda não verificado" },
        notMapped: { description: "Nenhum mapeamento openEHR registado" },
      },
      all: "Todos",
      noRestriction: "Sem restrição",
      sensitivityOptions: {
        plain: {
          label: "Plain",
          description: "Dados originais sem criptografia",
        },
        pseudonymized: {
          description: "IDs substituídos, reidentificável",
        },
        anonymized: {
          description: "Totalmente anonimizado",
        },
      },
      omopOptions: {
        validated: {
          description: "Mapeamento OMOP confirmado",
        },
        suggested: {
          description: "Sugestão da IA, não validada",
        },
        notMapped: {
          description: "Nenhum mapeamento OMOP disponível",
        },
      },
    },
    frequency: {
      sectionTitle: "Disponibilidade e análise de frequência",
      availableSince: "Disponível desde {{date}}",
      coverage: "Cobertura",
      stationAreas: "{{count}} áreas de estação",
      noStationData: "Sem dados de estação",
      moreAreas: "... mais {{count}} áreas",
      noDataAvailable: "Nenhum dado disponível",
      caseCoverage: "Cobertura de casos",
      allCases: "{{value}}% de todos os casos",
      casesOfTotal: "{{cases}} de {{total}} casos",
      noCaseData: "Sem dados de casos",
      volume: "Volume de medições",
      averagePerCase: "Média por caso",
      measurementsAverage: "⌀ {{value}} medições",
      median: "Mediana: {{value}}",
      noMeasurementData: "Sem dados de medição",
      total: "Total",
      measurementsLastYear: "Medições (último ano)",
      pattern: "Padrão de medição",
      typicalFrequency: "Frequência típica",
      interval: "⌀ intervalo de {{value}}",
      continuousMeasurements: "Medições contínuas",
      continuousCases: "{{count}} casos com >10 medições",
      noData: "Sem dados",
      cases: "Casos",
      stations: "Estações",
      suppressed: "Suprimido",
      suppressedExplanation: "Valor suprimido: contagem de casos abaixo do limite de anonimização.",
      suppressedExplanationWithThreshold: "Valor suprimido: contagem de casos abaixo do limite de {{threshold}}.",
      profilingSummary: "Extraído em {{date}}: {{totalMeasurements}} medições em {{casesWithParameter}} de {{totalCases}} admissões.",
      profilingSuppressionNote: "Agregados abaixo de {{threshold}} casos são suprimidos, não arredondados.",
      stationGroups: {
        icu: "Unidades de terapia intensiva",
        imc: "IMC (Cuidados Intermediários)",
        ward: "Enfermarias",
        opDiagnostics: "Centro cirúrgico e diagnóstico",
        lab: "Laboratório",
        other: "Outros",
      },
    },
    expanded: {
      unitsAndSources: "Unidades e fontes de dados",
      unitMeasurements: "{{count}} medições",
      unitNotRecorded: "(não registrado)",
      valueDistribution: "Distribuição de valores",
      valueDistributionOther: "outros",
      valueDistributionEmpty: "(sem indicação)",
      valueDistributionCount: "{{count}} medições",
      valueDistributionNotAvailable: "Sem distribuição de valores",
      standard: "Padrão",
      noteLabel: "Observação:",
      normalizationNotice:
        "Ao importar para o banco de dados OMOP, todos os valores são convertidos para a unidade padrão {{unit}}.",
      omopMapping: "Mapeamento OMOP",
      openehrMapping: "Mapeamento openEHR",
      codeLabel: "Código:",
      omopId: "ID OMOP: {{id}}",
      athenaOpen: "Abrir ATHENA",
      noMapping: "Nenhum mapeamento disponível",
      addToList: "Adicionar à lista",
      list: "Lista",
      allDetails: "Todos os detalhes",
    },
    mapping: {
      databaseMapping: "Mapeamento do banco de dados",
      definition: "Definição",
      measurements: "Medições",
      copied: "Copiado!",
      copyTableName: "Copiar nome da tabela",
      copyJoin: "Copiar join",
    },
    sensitivity: {
      levels: {
        offen: "Aberto",
        pseudonymisiert: "Pseudonimizado",
        anonymisiert: "Anonimizado",
        vertraulich: "Confidencial",
        strictlyConfidential: "Estritamente confidencial",
      },
      tooltips: {
        offen: "Sem restrições",
        pseudonymisiert: "Os dados identificáveis foram removidos",
        anonymisiert: "Totalmente anonimizado",
        vertraulich: "Acesso somente com aprovação especial",
        strictlyConfidential: "Nível máximo de confidencialidade",
      },
    },
    // Die zweite Darstellung (#772). Gleiches Statusvokabular wie OMOP --
    // `omopStatus` oben wird fuer beide benutzt, bewusst kein zweites.
    openehr: {
      keinArchetyp: "nenhum arquétipo registado",
      nichtInOmopAbbildbar: "não representável em OMOP",
      abbildbarkeitUnbekannt: "mapeamento para OMOP não avaliado",
      fragmentierung: "dividido por {{anzahl}} registos OMOP",
      aqlPfade: "Caminhos AQL",
      entsprichtOmop: "corresponde a OMOP {{code}}",
      archetypOhneZuordnung: "sem atribuição",
    },
    omopStatus: {
      validated: "Validado",
      mapped: "Mapeado",
      pending: "Pendente",
      suggested: "Sugerido",
      notMapped: "Não mapeado",
      unknown: "Desconhecido",
    },
    listComparison: {
      all: "Todos ({{count}})",
      onlyA: "Somente A: {{list}} ({{count}})",
      onlyB: "Somente B: {{list}} ({{count}})",
      both: "A ∩ B ({{count}})",
      neither: "Nenhum ({{count}})",
      neitherUnknown: "Nenhum (desconhecido)",
    },
  },
  cohorts: {
    title: "Coortes",
    subtitle: "Gerencie suas coortes de pacientes",
    table: {
      name: "Nome",
    },
    builder: {
      step1Title: "1. Selecionar lista de parâmetros",
      step1Description: "Selecione uma lista de parâmetros para carregar os parâmetros disponíveis no construtor.",
      parameterListLabel: "Lista de parâmetros",
      parametersCount: "{{count}} parâmetros",
      listDetails: "Detalhes da lista",
      createdAt: "Criada em: {{date}}",
      createdBy: "Por: {{user}}",
      loadListAndContinue: "Carregar lista e continuar",
      infoTitle: "Informações da coorte",
      nameLabel: "Nome da coorte",
      namePlaceholder: "ex.: pacientes com sepse e hipotensão",
      descriptionLabel: "Descrição",
      descriptionPlaceholder: "Descreva o objetivo e os critérios desta coorte",
      visibility: {
        publicTitle: "Pública",
        publicHint: "Visível para todos os usuários",
        privateTitle: "Privada",
        privateHint: "Visível apenas para você",
      },
      availableParameters: "Parâmetros disponíveis",
      loadedCount: "{{count}} carregados",
      searchPlaceholder: "Pesquisar parâmetros...",
      onlyUnused: "Apenas não utilizados",
      showAll: "Mostrar todos",
      usedCount: "{{count}} utilizados",
      noneFound: "Nenhum parâmetro correspondente encontrado.",
      includeButton: "Incluir",
      excludeButton: "Excluir",
      includeTitle: "Critérios de inclusão",
      includeEmpty: "Adicione parâmetros à esquerda para definir critérios de inclusão.",
      excludeTitle: "Critérios de exclusão",
      excludeEmpty: "Nenhum critério de exclusão definido.",
      operators: {
        operatorLabel: "Operador",
        valueLabel: "Valor",
        connectorLabel: "Conector",
        and: "E",
        or: "OU",
      },
      saveCohort: "Salvar coorte",
      validation: {
        selectParameterList: "Selecione primeiro uma lista de parâmetros.",
        enterName: "Insira um nome para a coorte.",
        enterDescription: "Insira uma descrição.",
        addInclusion: "Adicione pelo menos um critério de inclusão.",
        fillAllValues: "Preencha todos os valores das condições.",
      },
    },
  },
  requests: {
    subtitle: "Gerencie suas solicitações de dados",
    status: {
      pendingApproval: "Aguardando aprovação",
      inProgress: "Em andamento",
      inReview: "Em revisão",
      completed: "Concluída",
      rejected: "Rejeitada",
    },
    actions: {
      newRequest: "Nova solicitação",
      createRequest: "Criar solicitação",
      back: "Voltar",
      next: "Avançar",
    },
    tabs: {
      overview: "Visão geral",
      timeline: "Linha do tempo",
      chat: "Chat",
    },
    chat: {
      inputPlaceholder: "Digite uma mensagem...",
    },
    messages: {
      dataStewardTeam: "Equipe de Data Steward",
    },
  },
  dataCatalogHelp: {
    intro:
      "No Catálogo de Dados, sempre crie duas listas para o fluxo: a Lista A define parâmetros de coorte (WHO) usados no Cohort Builder para definir critérios, e a Lista B define a extração de dados (WHAT).",
    criteriaMeaning:
      "Critérios são condições médicas, como regras de inclusão/exclusão (por exemplo idade, diagnósticos e limites laboratoriais), usadas depois no Cohort Builder para refinar a população.",
    listA: {
      hint: "A Lista A contém parâmetros de coorte (WHO) usados no Cohort Builder para definir regras de inclusão e exclusão.",
      examples: ["Idade > 65", "Diagnóstico: Câncer de Pulmão", "Pressão arterial < 90 mmHg"],
    },
    listB: {
      hint: "A Lista B contém os campos de extração (WHAT): dados exportados em Solicitações.",
      examples: ["Frequência cardíaca", "Hemoglobina", "Histórico de medicação"],
    },
    workflowSteps: {
      catalog: "1. Catálogo de Dados",
      cohorts: "2. Cohort Builder",
      requests: "3. Solicitações",
    },
  },
  settings: {
    title: "Configurações",
    subtitle: "Gerencie as configurações da conta, empresa e aplicativo.",
    loading: "Carregando configurações…",
    tabAriaLabel: "Abas de configurações",
    authErrors: {
      notSignedIn: "Sessão não autenticada",
      unauthenticated: "Sua sessão não é mais válida. Faça login novamente.",
      connectionFailed: "Não foi possível carregar as configurações.",
    },
    authStatus: {
      connected: "Conectado ao serviço de autenticação",
    },
    time: {
      month: "mês",
      months: "meses",
      year: "ano",
      years: "anos",
    },
    tabs: {
      profile: "Perfil",
      organization: "Departamento",
      notifications: "Notificações",
      billing: "Cobrança",
      api: "API e Integrações",
      appearance: "Aparência",
      admin: "Painel Admin",
    },
    authWarningTitle: "Serviço de autenticação",
    authWarningFallback: "Falha na conexão",
    authWarningBody:
      "Não foi possível estabelecer conexão com o serviço de autenticação. Alguns recursos podem estar limitados.",
    buttons: {
      saveChanges: "Salvar alterações",
      saveSettings: "Salvar configurações",
      saveAllApi: "Salvar todas as configurações da API",
      saveWebhook: "Salvar",
      createOrganization: "Criar empresa",
      addMember: "Adicionar membro",
      inviteMember: "Convidar membro",
      invite: "Convidar",
      cancel: "Cancelar",
      add: "Adicionar",
      connect: "Conectar",
      testWebhook: "Testar webhook",
      generateNewKey: "Gerar nova chave",
      changeBillingDetails: "Alterar dados de cobrança",
      changeServicePackage: "Alterar pacote de serviço",
      endOtherSessions: "Encerrar todas as outras sessões",
      viewFullLogs: "Ver logs completos",
      pdf: "PDF",
      gotIt: "Entendi",
    },
    sections: {
      profile: {
        personalInformation: "Informações pessoais",
        securitySettings: "Configurações de segurança",
        summary: {
          email: "E-mail",
          phone: "Telefone",
          address: "Endereço",
        },
        fields: {
          name: "Nome",
          email: "E-mail",
          phone: "Telefone",
          role: "Cargo/Função",
          company: "Empresa",
          department: "Departamento",
          address: "Endereço",
          changePassword: "Alterar senha",
        },
        helpers: {
          emailManaged: "O endereço de e-mail é gerenciado pela sua conta e não pode ser alterado aqui.",
          passwordChangePlaceholder: "Altere isso na aba Privacidade e Segurança",
          passwordChangeHelp: "Use o fluxo completo de alteração de senha na aba Privacidade e Segurança.",
          goToSecurity: "Ir para Segurança",
          twoFactor: "Aumente a segurança da sua conta com uma verificação adicional no login.",
        },
        twoFactorLabel: "Ativar autenticação de dois fatores",
        avatarComingSoon: "O upload de foto de perfil está em breve.",
        uploadAvatar: "Fazer upload da foto de perfil",
        orgContext: {
          title: "Minha Organização",
          company: "Empresa",
          department: "Departamento",
          team: "Equipe",
          role: "Função",
          noInfo: "Ainda não atribuído",
        },
      },
      organization: {
        information: "Informações da empresa",
        members: "Membros da equipe",
        logoComingSoon: "O upload de logotipo está em breve.",
        uploadLogo: "Fazer upload do logotipo",
        summary: {
          size: "Tamanho da empresa",
          website: "Site",
          primaryColor: "Cor principal",
        },
        fields: {
          name: "Nome da empresa",
          type: "Tipo de empresa",
          size: "Tamanho da empresa",
          industry: "Setor",
          website: "Site",
          primaryColor: "Cor principal",
        },
        types: {
          hospital: "Hospital",
          clinic: "Clínica",
          research: "Instituição de pesquisa",
          university: "Universidade",
          pharma: "Empresa farmacêutica",
          biotech: "Empresa de biotecnologia",
          other: "Outro",
        },
        sizes: {
          "1-50": "1-50 funcionários",
          "51-200": "51-200 funcionários",
          "201-1000": "201-1000 funcionários",
          "1001-5000": "1001-5000 funcionários",
          "5000+": "5000+ funcionários",
        },
        roles: {
          admin: "Administrador",
          reviewer: "Revisor",
          analyst: "Analista",
          viewer: "Visualizador",
          member: "Membro",
          dept_admin: "Admin de Departamento",
          team_admin: "Admin de Equipe",
          data_steward: "Data Steward",
          guest: "Convidado",
        },
        actions: {
          edit: "Editar",
          remove: "Remover",
        },
        dialog: {
          title: "Adicionar novo membro da equipe",
          description: "Insira o endereço de e-mail do usuário. O usuário deve ter uma conta Argus.",
          email: "Endereço de e-mail",
          role: "Função",
        },
        teamHint: {
          title: "Membros da equipe",
          description: "{{count}} membro(s) na sua empresa",
          goToTeam: "Ir para Equipe",
        },
        noOrgYet: "Nenhuma empresa criada ainda.",
        companyReadOnlyNote: "Os dados da empresa são gerenciados pelo seu administrador e não podem ser editados aqui.",
        accordion: {
          company: "Empresa",
          departments: "Departamentos",
          noDepartments: "Nenhum departamento configurado ainda.",
          createDepartment: "Criar departamento",
          teams: "Equipes",
          noTeams: "Nenhuma equipe configurada ainda.",
          createTeam: "Criar equipe",
          members: "Membros",
          leaveTeam: "Sair da equipe",
        },
      },
      team: {
        title: "Membros da equipe",
        subtitle: "{{count}} membro(s) na sua empresa",
        noMembers: "Nenhum membro convidado ainda.",
        youLabel: "Você",
        noOrg: {
          title: "Nenhuma empresa ainda",
          description: "Crie uma empresa primeiro para convidar membros.",
          goToOrg: "Ir para Empresa",
        },
        editRoleDialog: {
          title: "Editar função",
          description: "Alterar função para {{email}}",
        },
        removeConfirm: {
          title: "Remover membro?",
          description: "Tem certeza que deseja remover {{name}} da empresa?",
          confirm: "Remover",
        },
      },
      notifications: {
        emailTitle: "Notificações por e-mail",
        inAppTitle: "Notificações no aplicativo",
        items: {
          newRequests: {
            title: "Novas solicitações de dados",
            email: "Receba um e-mail quando novas solicitações chegarem",
            inApp: "Receba uma notificação quando novas solicitações chegarem",
          },
          statusChanges: {
            title: "Mudanças de status",
            email: "Receba um e-mail quando o status das suas solicitações mudar",
            inApp: "Receba uma notificação quando o status das suas solicitações mudar",
          },
          messages: {
            title: "Novas mensagens",
            email: "Receba um e-mail quando receber novas mensagens",
            inApp: "Receba uma notificação quando receber novas mensagens",
          },
          billing: {
            title: "Informações de cobrança",
            email: "Receba um e-mail sobre cobranças e pagamentos",
            inApp: "Receba uma notificação sobre cobranças e pagamentos",
          },
          weeklyReport: {
            title: "Relatório semanal",
            email: "Receba um relatório semanal sobre suas solicitações",
          },
        },
      },
      privacy: {
        privacyTitle: "Configurações de privacidade",
        dataSharingTitle: "Compartilhamento de dados",
        dataSharingDescription: "Defina quanta informação sobre suas solicitações será compartilhada com clínicas parceiras.",
        dataSharingOptions: {
          minimal: "Mínimo - compartilhar apenas os dados necessários",
          standard: "Padrão - compartilhar informações básicas",
          extended: "Expandido - compartilhar informações detalhadas",
        },
        anonymizeLabel: "Anonimizar resultados",
        anonymizeDescription: "Quando ativado, todos os dados de pacientes nos resultados das análises são automaticamente anonimizados.",
        analyticsLabel: "Permitir análise de uso",
        analyticsDescription: "Permita que coletemos dados de uso anonimizados para melhorar o serviço.",
        retentionTitle: "Período de retenção dos dados de solicitações",
        retentionDescription: "Defina por quanto tempo os dados das suas solicitações devem ser armazenados.",
        retentionMarks: {
          months6: "6 meses",
          year1: "1 ano",
          years2: "2 anos",
          years3: "3 anos",
          years5: "5 anos",
        },
      },
      security: {
        title: "Configurações de segurança",
        twoFactorTitle: "Autenticação de dois fatores",
        statusEnabled: "Ativado",
        statusDisabled: "Desativado",
        enabledHelp: "Seu login está protegido por um segundo fator.",
        disabledHelp: "Ative esta opção para mais segurança.",
        currentPassword: "Senha atual",
        newPassword: "Nova senha",
        confirmPassword: "Confirmar nova senha",
        sessionManagement: "Gerenciamento de sessões",
        sessionHelp: "Encerra todas as sessões ativas, exceto a atual.",
        accessLogsTitle: "Logs de atividade",
        accessLogsDescription: "Revise a atividade da sua conta e os eventos de segurança.",
        accessLogsComingSoon: "Os logs de acesso estão sendo preparados e ainda não estão disponíveis.",
        accessLogsEmpty: "Nenhum log de atividade ainda.",
        refreshLogs: "Atualizar logs",
        accessLogCols: {
          event: "Evento",
          description: "Descrição",
          ip: "Endereço IP",
          time: "Hora",
        },
      },
      twoFa: {
        setupTitle: "Configurar autenticação de dois fatores",
        setupDescription: "Escaneie o QR code com o seu aplicativo autenticador (ex.: Google Authenticator ou Authy) e insira o código de 6 dígitos abaixo.",
        manualEntryLabel: "Chave manual (clique para copiar)",
        clickToCopy: "Copiar para a área de transferência",
        secretCopied: "Chave copiada.",
        codeLabel: "Código de 6 dígitos",
        verifyButton: "Verificar e ativar",
        disableTitle: "Desativar autenticação de dois fatores",
        disableDescription: "Tem certeza de que deseja desativar a autenticação de dois fatores? Sua conta ficará menos segura.",
        disableButton: "Desativar",
      },
      billing: {
        currentPlan: "Plano atual",
        nextBilling: "Próxima cobrança:",
        paymentMethod: "Método de pagamento:",
        institutionNumber: "Número da instituição:",
        invoiceHistory: "Histórico de faturas",
        invoiceId: "ID da fatura",
        date: "Data",
        amount: "Valor",
        status: "Status",
        actions: "Ações",
        billingAddress: "Endereço de cobrança",
        contactPerson: "Pessoa de contato",
        invoiceEmail: "E-mail para faturamento",
        vatId: "NIF/IVA",
        paid: "pago",
      },
      api: {
        settingsTitle: "Configurações da API",
        enableAccess: "Ativar acesso à API",
        enableAccessDescription: "Permite acesso aos dados do ARGUS pela API.",
        apiKey: "Chave da API",
        newKeyWarning: "Atenção: gerar uma nova chave invalidará a anterior.",
        toggleKeyVisibility: "Mostrar ou ocultar a chave da API",
        copyKey: "Copiar chave da API",
        rateLimit: "Limite de taxa",
        rateLimitDescription: "Número máximo de solicitações à API por hora.",
        requestsPerHour: "solicitações/hora",
        webhookTitle: "Configuração de webhook",
        webhookDescription: "Configure webhooks para receber notificações sobre eventos.",
        webhookUrl: "URL do webhook",
        webhookEvents: "Eventos",
        analysisResults: "Novos resultados de análise",
        statusChanges: "Mudanças de status",
        messages: "Novas mensagens",
        ipWhitelist: "Lista de IPs permitidos",
        ipWhitelistDescription: "Restrinja o acesso à API a endereços IP específicos.",
        newIpAddress: "Novo endereço IP",
        newIpPlaceholder: "ex.: 192.168.1.1",
        aiProvider: {
          title: "Provedor de IA",
          description: "Provedor, ID do modelo e (para modelos locais) endpoint para funções baseadas em IA. A lista de sugestões é uma ajuda, não uma restrição -- qualquer ID de modelo pode ser digitado livremente.",
          fields: {
            provider: "Provedor",
            providerPlaceholder: "ex.: OpenRouter",
            model: "ID do modelo",
            modelPlaceholder: "ex.: claude-sonnet-5",
            endpoint: "Endpoint",
          },
        },
        integrations: "Integrações",
        integrationsCards: {
          rStudio: "Conecte a plataforma ARGUS ao R Studio para análises automatizadas.",
          python: "Use bibliotecas Python para análise automatizada de dados e preparação de resultados.",
          tableau: "Crie dashboards para visualizar solicitações e estatísticas de análises.",
        },
      },
      appearance: {
        title: "Aparência",
        theme: "Esquema de cores",
        themes: {
          light: "Claro",
          dark: "Escuro",
          system: "Sistema",
        },
        primaryColor: "Cor principal",
        fontSize: "Tamanho da fonte",
        fontScale: {
          small: "Pequeno",
          normal: "Normal",
          large: "Grande",
        },
        animations: "Animações",
        animationsEnabled: "Ativar animações",
        languageRegion: "Idioma e região",
        switchLanguage: "Mudar idioma",
        dateFormat: "Formato da data",
        timeZone: "Fuso horário",
        timeZones: {
          berlin: "Europa/Berlim (GMT+1)",
          london: "Europa/Londres (GMT)",
          newYork: "América/Nova York (GMT-5)",
          tokyo: "Ásia/Tóquio (GMT+9)",
        },
        dashboard: "Configurações do painel",
        defaultHomepage: "Página inicial padrão",
        homepageOptions: {
          dashboard: "Painel",
          requests: "Solicitações recebidas",
          negotiations: "Negociações",
          executions: "Execuções",
        },
        widgets: {
          title: "Widgets do painel",
          incomingRequests: "Solicitações recebidas",
          statistics: "Estatísticas",
          runningAnalyses: "Análises em andamento",
          paymentOverview: "Visão de pagamentos",
          activityLog: "Registro de atividades",
        },
      },
    },
    snackbars: {
      authRequired: "Erro: sessão não autenticada",
      noOrganization: "Erro: nenhuma empresa encontrada",
      orgNameRequired: "Por favor, insira um nome para a empresa.",
      emailRequired: "Por favor, insira um endereço de e-mail.",
      profileSaved: "Configurações do perfil salvas com sucesso.",
      organizationCreated: "Empresa criada com sucesso.",
      organizationSaved: "Configurações da empresa salvas com sucesso.",
      notificationsSaved: "Configurações de notificações salvas com sucesso.",
      privacySaved: "Configurações de privacidade e segurança salvas com sucesso.",
      apiSaved: "Configurações da API salvas com sucesso.",
      appearanceSaved: "Configurações de aparência salvas com sucesso.",
      genericSaved: "Configurações de {{section}} salvas com sucesso.",
      saveError: "Erro ao salvar: {{message}}",
      addMemberSuccess: "Membro da equipe adicionado com sucesso.",
      addMemberNotFound: "Nenhuma conta Argus encontrada com este e-mail.",
      addMemberError: "Erro ao adicionar membro: {{message}}",
      removeMemberSuccess: "Membro da equipe removido.",
      removeMemberError: "Erro ao remover membro: {{message}}",
      memberRoleUpdated: "Função do membro atualizada com sucesso.",
      memberRoleUpdateError: "Erro ao atualizar função: {{message}}",
      apiKeyGenerated: "Uma nova chave da API foi gerada e salva.",
      apiKeyGenerateError: "Falha ao gerar chave de API: {{message}}",
      duplicateIp: "Este endereço IP já existe.",
      invalidIp: "Formato de endereço IP inválido. Use ex. 192.168.1.1 ou 10.0.0.0/24.",
      oldPasswordRequired: "Por favor, insira sua senha atual.",
      passwordTooShort: "A nova senha deve ter pelo menos 8 caracteres.",
      passwordMismatch: "A nova senha e a confirmação não correspondem.",
      sessionEnded: "Todas as outras sessões foram encerradas.",
      sessionEndError: "Falha ao encerrar sessões: {{message}}",
      webhookTested: "Teste de webhook enviado.",
      webhookTestError: "Teste de webhook falhou: {{message}}",
      apiKeyCopied: "Chave de API copiada para a área de transferência.",
      avatarSaved: "Foto de perfil salva.",
      avatarSaveError: "Falha ao salvar foto de perfil: {{message}}",
      logoSaved: "Logotipo salvo.",
      logoSaveError: "Falha ao salvar logotipo: {{message}}",
      invalidImageType: "Por favor, selecione um arquivo de imagem válido.",
      imageTooLarge: "O arquivo de imagem deve ter no máximo 5 MB.",
      twoFaSetupError: "Falha na configuração do 2FA: {{message}}",
      twoFaCodeRequired: "Por favor, insira o código de 6 dígitos do seu aplicativo autenticador.",
      twoFaEnabled: "A autenticação de dois fatores foi ativada com sucesso.",
      twoFaVerifyError: "Falha na verificação do código: {{message}}",
      twoFaDisabled: "A autenticação de dois fatores foi desativada.",
      twoFaDisableError: "Falha ao desativar o 2FA: {{message}}",
    },
  },
  supportPage: {
    title: "Ajuda e Documentação",
    subtitle: "Ajuda central para o fluxo do Olymp: Data Catalog -> Cohort Builder -> Requests.",
    searchPlaceholder: "Pesquisar em ajuda, fluxo, FAQ, glossário e contato...",
    tabs: {
      gettingStarted: "Primeiros passos",
      workflow: "Fluxo",
      faqs: "FAQs",
      glossary: "Glossário",
      contact: "Contato",
    },
    chips: {
      gettingStarted: "Primeiros passos",
      workflow: "Fluxo",
      faqs: "FAQs",
      glossary: "Glossário",
      contact: "Contato",
    },
    sections: {
      workflowTitle: "Guias de fluxo",
      glossaryTitle: "Glossário",
      contactTitle: "Contato e suporte",
      faqTitle: "Perguntas frequentes (FAQ)",
    },
    actions: {
      openSection: "Abrir seção",
    },
    content: {
      gettingStartedSteps: [
        {
          title: "1. Preparar catálogo de dados",
          description: "Crie Lista A (critérios) e Lista B (extração) para iniciar o fluxo de forma organizada.",
          actionLabel: "Ir para Catálogo de Dados",
          actionPath: "/catalog",
        },
        {
          title: "2. Construir coorte",
          description: "Defina e refine a população no Cohort Builder (lista e grafo).",
          actionLabel: "Ir para Cohort Builder",
          actionPath: "/cohorts",
        },
        {
          title: "3. Enviar solicitação",
          description: "Combine WHO (coorte) e WHAT (Lista B) e crie uma solicitação de dados.",
          actionLabel: "Ir para Solicitações",
          actionPath: "/requests",
        },
      ],
      faqItems: [
        {
          question: "Qual é a diferença entre Lista A e Lista B?",
          answer: "A Lista A define os critérios da coorte (WHO), a Lista B define os campos de dados para extração (WHAT).",
        },
      ],
    },
  },
});

// Blaetterung der Katalogseite (argus-platform #193) und die drei unterscheidbaren
// Zustaende Laden / Leer / Fehler (#191). Bewusst eigene Schluessel fuer "unbekannte
// Trefferzahl": "0 Parameter gefunden" waehrend des Ladens ist eine Falschaussage.
mergeDeep(resources.de.translation, {
  dataCatalog: {
    resultCountLoading: "Parameter werden geladen…",
    resultCountUnknown: "Trefferzahl unbekannt",
    pagination: {
      range: "{{von}}–{{bis}} von {{gesamt}}",
      pageSize: "Pro Seite",
      aria: "Seiten des Katalogs",
    },
    table: {
      empty: "Keine Parameter fuer diese Filter.",
      emptyBecauseError: "Der Katalog konnte nicht geladen werden — die Meldung steht oben.",
    },
  },
});

mergeDeep(resources.en.translation, {
  dataCatalog: {
    resultCountLoading: "Loading parameters…",
    resultCountUnknown: "Result count unknown",
    pagination: {
      range: "{{von}}–{{bis}} of {{gesamt}}",
      pageSize: "Per page",
      aria: "Catalog pages",
    },
    table: {
      empty: "No parameters for these filters.",
      emptyBecauseError: "The catalog could not be loaded — see the message above.",
    },
  },
});

mergeDeep(ptTranslation, {
  dataCatalog: {
    startMappingBatch: "Iniciar lote de mapeamento",
    resultCountLoading: "Carregando parâmetros…",
    resultCountUnknown: "Número de resultados desconhecido",
    pagination: {
      range: "{{von}}–{{bis}} de {{gesamt}}",
      pageSize: "Por página",
      aria: "Páginas do catálogo",
    },
    table: {
      empty: "Nenhum parâmetro para estes filtros.",
      emptyBecauseError: "O catálogo não pôde ser carregado — veja a mensagem acima.",
    },
  },
});

// Job-Monitor (#97): eigener Namensraum statt der bisherigen sprachlokalen
// Kopie in JobMonitor.js -- die Uebersetzung gehoert in die zentrale
// i18n-Struktur, nicht in eine zweite, komponenteneigene Tabelle.
mergeDeep(resources.de.translation, {
  jobMonitor: {
    status: {
      pending: "Ausstehend",
      running: "Läuft",
      completed: "Fertig",
      failed: "Fehlgeschlagen",
      cancelled: "Abgebrochen",
      stopped_budget: "Budget erreicht",
      unknown: "Unbekannt",
    },
    cancel: "Abbrechen",
    cancelling: "Wird abgebrochen...",
    cost: "Kosten bisher",
    errors: "Fehler",
    loadError: "Der Job-Status konnte nicht geladen werden.",
  },
});

mergeDeep(resources.en.translation, {
  jobMonitor: {
    status: {
      pending: "Pending",
      running: "Running",
      completed: "Completed",
      failed: "Failed",
      cancelled: "Cancelled",
      stopped_budget: "Budget limit reached",
      unknown: "Unknown",
    },
    cancel: "Cancel",
    cancelling: "Cancelling...",
    cost: "Cost so far",
    errors: "Errors",
    loadError: "Could not load the job status.",
  },
});

mergeDeep(ptTranslation, {
  jobMonitor: {
    status: {
      pending: "Pendente",
      running: "Em execução",
      completed: "Concluído",
      failed: "Falhou",
      cancelled: "Cancelado",
      stopped_budget: "Limite de orçamento atingido",
      unknown: "Desconhecido",
    },
    cancel: "Cancelar",
    cancelling: "A cancelar...",
    cost: "Custo até agora",
    errors: "Erros",
    loadError: "Não foi possível carregar o estado do job.",
  },
});

// Mapping-Batch-Start-Dialog (#96): startet einen Mapping-Job ueber eine
// Parameterauswahl, Modellwahl und Kostendeckel -- eigener Namensraum wie
// bei jobMonitor oben, keine komponenteneigene Kopie.
mergeDeep(resources.de.translation, {
  mappingBatchDialog: {
    title: "Mapping-Batch starten",
    modeUnmapped: "Alle ungemappten Parameter",
    modeFilter: "Nach Filter",
    filterLabel: "Suchbegriff",
    filterApply: "Anwenden",
    parametersLoading: "Parameter werden geladen...",
    parametersLoadError: "Parameter konnten nicht geladen werden.",
    selectedCount: "{{count}} Parameter ausgewaehlt",
    modelLabel: "Modell",
    modelsLoadError: "Modelle konnten nicht geladen werden.",
    noActiveModel: "Kein aktives Modell konfiguriert.",
    goToSettings: "Zu den Einstellungen",
    costCapLabel: "Kostendeckel (EUR)",
    jobMonitorHint: "Der Fortschritt wird nach dem Start im Job-Monitor angezeigt.",
    startError: "Der Mapping-Batch konnte nicht gestartet werden.",
    cancel: "Abbrechen",
    start: "Batch starten",
    starting: "Wird gestartet...",
  },
});

mergeDeep(resources.en.translation, {
  mappingBatchDialog: {
    title: "Start mapping batch",
    modeUnmapped: "All unmapped parameters",
    modeFilter: "By filter",
    filterLabel: "Search term",
    filterApply: "Apply",
    parametersLoading: "Loading parameters...",
    parametersLoadError: "Parameters could not be loaded.",
    selectedCount: "{{count}} parameters selected",
    modelLabel: "Model",
    modelsLoadError: "Models could not be loaded.",
    noActiveModel: "No active model configured.",
    goToSettings: "Go to settings",
    costCapLabel: "Cost cap (EUR)",
    jobMonitorHint: "Progress is shown in the job monitor after starting.",
    startError: "The mapping batch could not be started.",
    cancel: "Cancel",
    start: "Start batch",
    starting: "Starting...",
  },
});

mergeDeep(ptTranslation, {
  mappingBatchDialog: {
    title: "Iniciar lote de mapeamento",
    modeUnmapped: "Todos os parâmetros não mapeados",
    modeFilter: "Por filtro",
    filterLabel: "Termo de pesquisa",
    filterApply: "Aplicar",
    parametersLoading: "A carregar parâmetros...",
    parametersLoadError: "Não foi possível carregar os parâmetros.",
    selectedCount: "{{count}} parâmetros selecionados",
    modelLabel: "Modelo",
    modelsLoadError: "Não foi possível carregar os modelos.",
    noActiveModel: "Nenhum modelo ativo configurado.",
    goToSettings: "Ir para as definições",
    costCapLabel: "Limite de custo (EUR)",
    jobMonitorHint: "O progresso é apresentado no monitor de jobs após o início.",
    startError: "Não foi possível iniciar o lote de mapeamento.",
    cancel: "Cancelar",
    start: "Iniciar lote",
    starting: "A iniciar...",
  },
});

// Job-Monitor-Seite (#96 Rueckmeldung Runde 1, Blocker B3): eigene Route, auf
// die der Batch-Start-Dialog nach dem Start verweist -- JobMonitor.js (#97)
// selbst traegt keinen Seitentitel/Zurueck-Link, das ist Sache der Seite, die
// ihn einbettet.
mergeDeep(resources.de.translation, {
  mappingJobMonitorPage: {
    title: "Mapping-Job",
    back: "Zurück zum Katalog",
  },
});

mergeDeep(resources.en.translation, {
  mappingJobMonitorPage: {
    title: "Mapping job",
    back: "Back to catalog",
  },
});

mergeDeep(ptTranslation, {
  mappingJobMonitorPage: {
    title: "Job de mapeamento",
    back: "Voltar ao catálogo",
  },
});

resources.pt = {
  translation: ptTranslation,
};

export default resources;
